(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $f503f4e8b4654857$exports = {};
$f503f4e8b4654857$exports = axios;


const $1c8afd417561b3bb$export$546f71b8cb2147a0 = (response)=>{
    if (response.data) {
        if (response.data.message) return response.data.message;
        if (response.data.data) return response.data.data;
    }
    return "Something went wrong.";
};
const $1c8afd417561b3bb$export$834dfce7b095c052 = (response)=>{
    if (!response.data) return $1c8afd417561b3bb$export$546f71b8cb2147a0(response);
    return response.data.data;
};


function $aee93ab2b11cc40f$var$trackCount(adId, actionType) {
    if (!adId || !actionType) return;
    const formData = new FormData();
    formData.append("action", "pm_track_ads_stat");
    formData.append("nonce", pm.nonces.trackSpcStat);
    formData.append("ads_id", adId.toString());
    formData.append("action_type", actionType);
    (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
        method: "post",
        url: pm.ajaxurl,
        data: formData
    }).then((axiosResponse)=>{
        const response = axiosResponse.data;
        if (!response || !response.success) {
            const errorMsg = (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(axiosResponse);
            console.error(errorMsg);
            return;
        }
    }).catch((response)=>{
        const errorMsg = (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response);
        console.error(errorMsg);
    }).then(()=>{});
}
var $aee93ab2b11cc40f$export$2e2bcd8739ae039 = $aee93ab2b11cc40f$var$trackCount;


function $2e33a4f4aeb13ba1$export$fea330ef6103f535(button) {
    if (!button) return;
    button.classList.add("is-loading");
}
function $2e33a4f4aeb13ba1$export$4dabcd056c1d895c(button) {
    if (!button) return;
    button.classList.remove("is-loading");
}




const $082fa2eaa5a44d4a$export$f849cc6a5aab7628 = async (opts)=>{
    const formData = new FormData();
    formData.append("action", opts.action);
    formData.append("nonce", opts.nonce);
    formData.append("post_id", opts.photoId.toString());
    try {
        const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
            method: "post",
            url: pm.ajaxurl,
            data: formData
        });
        if (!axiosResponse.data || !axiosResponse.data.success) return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$834dfce7b095c052)(axiosResponse),
            data: []
        };
        return axiosResponse.data;
    } catch (response) {
        return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response),
            data: []
        };
    }
};
const $082fa2eaa5a44d4a$export$2e6e3ad634e3776 = async (id)=>{
    const formData = new FormData();
    formData.append("action", "pm_delete_comment");
    formData.append("nonce", pm.nonces.deleteComment);
    formData.append("comment_id", id.toString());
    try {
        const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
            method: "post",
            url: pm.ajaxurl,
            data: formData
        });
        if (!axiosResponse.data || !axiosResponse.data.success) return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$834dfce7b095c052)(axiosResponse)
        };
        return {
            success: true,
            message: axiosResponse.data.data
        };
    } catch (response) {
        return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response)
        };
    }
};
const $082fa2eaa5a44d4a$export$f68f1e500e5465ae = async (id, actionType)=>{
    const formData = new FormData();
    formData.append("action", "pm_like_comment");
    formData.append("nonce", pm.nonces.likeComment);
    formData.append("comment_id", id.toString());
    formData.append("action_type", actionType);
    try {
        const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
            method: "post",
            url: pm.ajaxurl,
            data: formData
        });
        if (!axiosResponse.data || !axiosResponse.data.success) return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$834dfce7b095c052)(axiosResponse)
        };
        return {
            success: true,
            message: axiosResponse.data.data.message,
            totalLikes: axiosResponse.data.data.totalLikes
        };
    } catch (response) {
        return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response)
        };
    }
};
const $082fa2eaa5a44d4a$export$91a3bff937566879 = async (opts)=>{
    const formData = new FormData();
    formData.append("action", opts.action);
    formData.append("nonce", opts.nonce);
    formData.append("post_id", opts.postId.toString());
    formData.append("parent_id", opts.parentId.toString());
    formData.append("content", opts.content);
    try {
        const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
            method: "post",
            url: pm.ajaxurl,
            data: formData
        });
        if (!axiosResponse.data || !axiosResponse.data.success) return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$834dfce7b095c052)(axiosResponse)
        };
        return axiosResponse.data;
    } catch (response) {
        return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response)
        };
    }
};


var $295ade7e963bc86d$exports = {};
$295ade7e963bc86d$exports = Tribute;


function $fbe10e17a894f2b8$export$2e2bcd8739ae039() {
    const { findFormEl: findFormEl, getClosest: getClosest } = pm.utils.dom;
    let tributeInstance = null;
    // ! Couldn't get tribute.append to work, so yea.. let's load them all.
    let limit = 1000000;
    let currentPage = 1;
    let offset = 0;
    let totalLoaded = 0;
    let isProcessing = false;
    init();
    function init() {
        document.addEventListener("click", handleDocumentClick);
        document.addEventListener("keydown", handleDocumentKeydown);
        // setupMention();
        const commentForm = findFormEl("#commentform");
        if (commentForm) setupCommentForm(commentForm);
    }
    async function handleDocumentClick(e) {
        const target = e.target;
        const button = getClosest(target, ".delete-comment", 10);
        if (!button) return;
        let commentId = button.dataset.commentId;
        if (!commentId) return;
        await removeComment(parseInt(commentId, 10), button);
    }
    function handleDocumentKeydown(e) {
        const target = e.target;
        if (!target) return;
        if (target.tagName.toLowerCase() !== "textarea") return;
        if (!target.classList.contains("comment-form-textarea")) return;
        const commentForm = getClosest(target, ".comment-form", 5);
        if (!commentForm) return;
        const value = target.value.trim();
        if (value) {
            const errorNotice = commentForm.querySelector(".comment-form-error-message");
            if (errorNotice) {
                errorNotice.innerHTML = "";
                errorNotice.classList.add("is-hidden");
            }
        }
    }
    async function removeComment(commentId, button) {
        if (isProcessing) return;
        if (!confirm("Are you sure you want to delete this comment?")) return;
        const wrapper = document.querySelector("#comment-" + button.dataset.commentId);
        if (!wrapper) return;
        const commentListWrapper = getClosest(wrapper, ".commentlist", 25);
        if (!commentListWrapper) return;
        isProcessing = true;
        (0, $2e33a4f4aeb13ba1$export$fea330ef6103f535)(button);
        const response = await (0, $082fa2eaa5a44d4a$export$2e6e3ad634e3776)(commentId);
        if (response.success) setTimeout(function() {
            const commentsCount = commentListWrapper.querySelector("#comments-title span");
            wrapper.parentNode.removeChild(wrapper);
            if (commentsCount) {
                const totalComments = commentListWrapper.querySelectorAll(".comments li[data-comment-id]").length;
                commentsCount.textContent = totalComments.toString();
                const commentsTitle = commentsCount.parentNode;
                if (!totalComments) commentsTitle.classList.add("is-hidden");
                else commentsTitle.classList.remove("is-hidden");
            }
        }, 150);
        isProcessing = false;
        (0, $2e33a4f4aeb13ba1$export$4dabcd056c1d895c)(button);
    }
    function setupMention() {
        // Create new tribute instance.
        tributeInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($295ade7e963bc86d$exports)))({
            lookup: function(user, mentionText) {
                return user.user_nicename + " - " + user.display_name;
            },
            selectTemplate: function(item) {
                return "@" + item.original.user_nicename;
            },
            values: []
        });
    // getTributeValues();
    }
    function getTributeValues() {
        jQuery.ajax({
            url: pm.ajaxurl,
            type: "POST",
            data: {
                action: "pm_get_tribute_values",
                nonce: pm.nonces.getTributeValues,
                limit: limit,
                offset: offset
            }
        }).done(function(r) {
            if (!r.success) return;
            if (r.data.length < 1) return;
            if (totalLoaded > 0) // Append values to our tribute instance.
            tributeInstance?.append(totalLoaded - 1, r.data);
            else // Append values to our tribute instance.
            tributeInstance?.append(0, r.data);
            currentPage++;
            offset += limit;
            totalLoaded += r.data.length;
            getTributeValues();
        }).fail(function(jqXHR) {
            console.log(buildErrorMsg(jqXHR));
        });
    }
    function setupCommentForm(form) {
        const field = form.querySelector(".comment-form-textarea");
        if (field instanceof HTMLTextAreaElement) tributeInstance?.attach(field);
        form.addEventListener("submit", onCommentFormSubmit);
    }
    function onCommentFormSubmit(e) {
        const commentField = this.querySelector(".comment-form-textarea");
        if (!(commentField instanceof HTMLTextAreaElement)) return;
        const value = commentField.value.trim();
        const errorNotice = this.querySelector(".comment-form-error-message");
        if (!(errorNotice instanceof HTMLElement)) return;
        if (!value) {
            e.preventDefault();
            errorNotice.innerHTML = "Please enter a comment.";
            errorNotice.classList.remove("is-hidden");
        }
    }
    function buildErrorMsg(jqXHR) {
        var errorMsg = jqXHR.responseJSON && jqXHR.responseJSON.data ? jqXHR.responseJSON.data : "Something went wrong";
        return errorMsg;
    }
}




function $942abde8c17ce155$export$2e2bcd8739ae039() {
    const { getClosest: getClosest } = pm.utils.dom;
    let isProcessing = {};
    document.addEventListener("click", handleDocumentClick);
    async function handleDocumentClick(e) {
        const target = e.target;
        if (!target) return;
        const likeButton = getClosest(target, ".like-comment", 10);
        if (!likeButton || !likeButton.tagName) return;
        await likeOrUnlikeComment(likeButton);
    }
    async function likeOrUnlikeComment(button) {
        const commentId = button.dataset.commentId ? parseInt(button.dataset.commentId, 10) : 0;
        const commentKey = "comment_" + commentId;
        if (!isProcessing.hasOwnProperty(commentKey)) isProcessing[commentKey] = false;
        if (isProcessing[commentKey]) return;
        const wrapper = document.querySelector("#comment-" + button.dataset.commentId);
        if (!wrapper) return;
        isProcessing[commentKey] = true;
        if (button) (0, $2e33a4f4aeb13ba1$export$fea330ef6103f535)(button);
        const actionType = button.classList.contains("is-liked") ? "unlike" : "like";
        // Let's visually like/unlike the comment even before the ajax request is started.
        if (actionType === "like") visuallyLikeComment(button);
        else visuallyUnlikeComment(button);
        const response = await (0, $082fa2eaa5a44d4a$export$f68f1e500e5465ae)(commentId, actionType);
        if (response.success) updateCounts(button, response.totalLikes ? response.totalLikes : 0);
        else // If action is failed, revert the button status.
        if (actionType === "like") visuallyUnlikeComment(button);
        else visuallyLikeComment(button);
        isProcessing[commentKey] = false;
        if (button) (0, $2e33a4f4aeb13ba1$export$4dabcd056c1d895c)(button);
    }
    /**
   * Visually like a comment.
   *
   * @param button The targetted button.
   */ function visuallyLikeComment(button) {
        button.classList.add("is-liked");
        const iconTitle = button.querySelector("svg title");
        if (iconTitle) iconTitle.innerHTML = "Unlike this comment";
    }
    /**
   * Visually unlike a comment.
   *
   * @param button The targetted button.
   */ function visuallyUnlikeComment(button) {
        button.classList.remove("is-liked");
        const iconTitle = button.querySelector("svg title");
        if (iconTitle) iconTitle.innerHTML = "Like this comment";
    }
    /**
   * Update the comment counts.
   *
   * @param button The targetted button.
   * @param totalLikes The total likes.
   */ function updateCounts(button, totalLikes) {
        const el = button.parentNode.querySelector(".total-likes");
        if (!el) return;
        el.textContent = totalLikes.toString();
        if (totalLikes > 0) el.classList.remove("is-hidden");
        else el.classList.add("is-hidden");
    }
}


/**
 * A single context menu element that can be opened "on demand".
 */ const $8b9578a55ec63129$var$contextMenu = document.querySelector(".context-menu");
const $8b9578a55ec63129$var$gallery = document.querySelector(".photo-grid");
// let lastWindowScrollY = window.scrollY;
const $8b9578a55ec63129$var$initContextMenu = ()=>{
    const { getClosest: getClosest } = pm.utils.dom;
    function init() {
        if (!$8b9578a55ec63129$var$contextMenu) return;
        // window.addEventListener("scroll", onWindowScroll);
        window.addEventListener("keydown", onWindowKeydown);
        document.addEventListener("click", onDocumentClick);
        pm.event.on("context_menu_close", hide);
        if ($8b9578a55ec63129$var$gallery) $8b9578a55ec63129$var$gallery.addEventListener("contextmenu", onPhotoRightClick);
    }
    // function onWindowScroll(e: Event) {
    // 	if (!contextMenu) return;
    //
    // 	// When context menu is open, prevent scrolling.
    // 	if (contextMenu.classList.contains("is-open")) {
    // 		e.preventDefault();
    // 		window.scrollTo(0, lastWindowScrollY);
    // 		return;
    // 	} else {
    // 		lastWindowScrollY = window.scrollY;
    // 	}
    // }
    function show(target, e) {
        if (!$8b9578a55ec63129$var$contextMenu) return;
        const bounds = target.getBoundingClientRect();
        const x = e.clientX - bounds.left;
        const y = e.clientY - bounds.top;
        $8b9578a55ec63129$var$contextMenu.style.left = x + "px";
        $8b9578a55ec63129$var$contextMenu.style.top = y + "px";
        $8b9578a55ec63129$var$contextMenu.classList.add("is-open");
    }
    function hide() {
        if (!$8b9578a55ec63129$var$contextMenu) return;
        if (!$8b9578a55ec63129$var$contextMenu.classList.contains("is-open")) return;
        emitPreclosingEvent();
        $8b9578a55ec63129$var$contextMenu.classList.remove("is-open");
        document.body.appendChild($8b9578a55ec63129$var$contextMenu);
    }
    function hideByClick(e) {
        const target = e.target;
        if (!target.classList.contains("close-on-click")) {
            if (getClosest(target, ".context-menu")) return;
        }
        hide();
    }
    function emitPreclosingEvent() {
        pm.event.emit("before_context_menu_close", {});
    }
    function onWindowKeydown(e) {
        const key = e.key.toLowerCase();
        if (key === "escape" || key === "esc") hide();
    }
    function onDocumentClick(e) {
        if (!getClosest(e.target, ".context-menu")) {
            hideByClick(e);
            return;
        }
        if (getClosest(e.target, ".close-on-click")) {
            hideByClick(e);
            return;
        }
    }
    function onPhotoRightClick(e) {
        e.preventDefault();
        let photo = getClosest(e.target, ".has-context-menu");
        if (!photo) return;
        const photoWrapper = photo.parentNode;
        if (!photoWrapper) return;
        const photoId = photoWrapper.dataset.photoId;
        $8b9578a55ec63129$var$contextMenu.dataset.photoId = photoId;
        const gridItem = photoWrapper.parentNode;
        if (!gridItem) return;
        // Move the contextMenu element to be inside the grid item.
        gridItem.appendChild($8b9578a55ec63129$var$contextMenu);
        pm.event.emit("before_context_menu_open", {
            photoId: photoId,
            photo: photo,
            photoWrapper: photoWrapper
        });
        show(gridItem, e);
    }
    init();
};
var $8b9578a55ec63129$export$2e2bcd8739ae039 = $8b9578a55ec63129$var$initContextMenu;


function $50f0c64592dcb09a$export$2e2bcd8739ae039() {
    const { getClosest: getClosest } = pm.utils.dom;
    const notices = document.querySelectorAll(".dots-menu .submission-notice");
    document.addEventListener("click", handleDocumentClick);
    window.addEventListener("keydown", handleWindowKeydown);
    /**
   * Function to run on document click event.
   *
   * @param e
   */ function handleDocumentClick(e) {
        const target = e.target;
        if (!target) return;
        const menu = getClosest(target, ".dots-menu", 10);
        if (menu) {
            if (menu.classList.contains("is-open")) {
                const clickedItem = getClosest(target, ".dots-menu-click", 10);
                if (clickedItem && clickedItem.classList.contains("close-on-click")) closeDropdownMenu(menu);
            } else openDropdownMenu(menu);
        } else closeAllDropdownMenuExcept();
    }
    /**
   * Function to run on window keydown event.
   *
   * @param e
   */ function handleWindowKeydown(e) {
        if (!e.key) return;
        const key = e.key.toLowerCase();
        if (key === "escape" || key === "esc") closeAllDropdownMenuExcept();
    }
    /**
   * Open targetted dropdown menu.
   *
   * @param menu
   */ function openDropdownMenu(menu) {
        pm.event.emit("dots_menu_open", {
            menu: menu
        });
        if (notices) notices.forEach(function(notice) {
            notice.classList.add("is-hidden");
            notice.textContent = "";
        });
        closeAllDropdownMenuExcept(menu);
        menu.classList.add("is-open");
    }
    /**
   * Close targetted dropdown menu.
   *
   * @param menu
   */ function closeDropdownMenu(menu) {
        menu.classList.remove("is-open");
    }
    /**
   * Close all dropdown menus with optional exclusion.
   *
   * If you want to exclude a menu from the process,
   * then provide it as `menuToSkip`.
   *
   * @param menuToSkip
   */ function closeAllDropdownMenuExcept(menuToSkip) {
        const menus = document.querySelectorAll(".dots-menu");
        if (!menus.length) return;
        menus.forEach(function(menu) {
            if (menu === menuToSkip) return;
            closeDropdownMenu(menu);
        });
    }
}


function $c442b09f19ddf753$export$4d9d47d3d2575b2c(button, photoId, isLiked, totalLikes) {
    button.dataset.photoId = photoId.toString();
    const activeClassName = "is-active";
    const hiddenClassName = "is-hidden";
    if (!isLiked) button.classList.remove(activeClassName);
    else button.classList.add(activeClassName);
    const totalLikesEl = button.querySelector(".total-likes");
    if (totalLikesEl) {
        if (totalLikes > 0) totalLikesEl.classList.remove(hiddenClassName);
        else totalLikesEl.classList.add(hiddenClassName);
        totalLikesEl.textContent = totalLikes.toString();
    }
    const textLabel = button.querySelector(".button-text");
    if (textLabel) textLabel.innerHTML = totalLikes > 1 ? "Likes" : "Like";
}




const $0e7a26d8219ed123$export$d36f66944659a9eb = async (ids, nonce)=>{
    const formData = new FormData();
    formData.append("action", "pm_fetch_specific_categories");
    formData.append("nonce", nonce);
    formData.append("ids", ids.join(", ").trim());
    try {
        const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
            method: "post",
            url: pm.ajaxurl,
            data: formData
        });
        if (!axiosResponse.data || !axiosResponse.data.success) return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$834dfce7b095c052)(axiosResponse),
            data: []
        };
        return axiosResponse.data;
    } catch (response) {
        return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response),
            data: []
        };
    }
};


const { findHtmlEl: $44088ef06c06c6cd$var$findHtmlEl, emptyElement: $44088ef06c06c6cd$var$emptyElement } = pm.utils.dom;
function $44088ef06c06c6cd$export$2e2bcd8739ae039(popup, categoryIds) {
    const listWrapper = $44088ef06c06c6cd$var$findHtmlEl(popup, ".category-list");
    if (!listWrapper) return;
    if (categoryIds.length === 0) {
        listWrapper.style.display = "none";
        return;
    }
    $44088ef06c06c6cd$var$buildCategoryPlaceholders(categoryIds, listWrapper);
    const nonce = popup.dataset.fetchCategoriesNonce ? popup.dataset.fetchCategoriesNonce : "";
    // No need to handle the "catch" here because it's handled in the service.
    (0, $0e7a26d8219ed123$export$d36f66944659a9eb)(categoryIds, nonce).then((response)=>{
        if (!response.success) return;
        const categoryDataList = response.data;
        // Remove items inside listWrapper except first one.
        while(listWrapper.children.length > 1)listWrapper.removeChild(listWrapper.lastChild);
        $44088ef06c06c6cd$var$buildCategoryItems(categoryDataList, listWrapper);
    });
}
function $44088ef06c06c6cd$var$buildCategoryPlaceholders(categoryIds, listWrapper) {
    $44088ef06c06c6cd$var$emptyElement(listWrapper);
    for(let i = 0; i < categoryIds.length; i++){
        const a = document.createElement("a");
        a.classList.add("is-waiting");
        a.innerHTML = "&nbsp;";
        a.href = "";
        a.style.minWidth = "85px";
        const li = document.createElement("li");
        li.style.marginRight = "7px";
        li.appendChild(a);
        listWrapper.appendChild(li);
    }
}
function $44088ef06c06c6cd$var$buildCategoryItems(categoryDataList, listWrapper) {
    $44088ef06c06c6cd$var$emptyElement(listWrapper);
    for(let i = 0; i < categoryDataList.length; i++){
        const a = document.createElement("a");
        a.href = categoryDataList[i].url;
        a.innerHTML = categoryDataList[i].name;
        const li = document.createElement("li");
        li.style.marginRight = "7px";
        li.appendChild(a);
        listWrapper.appendChild(li);
    }
}


const { findHtmlEl: $11d26a5cd5e96053$var$findHtmlEl, findHtmlEls: $11d26a5cd5e96053$var$findHtmlEls } = pm.utils.dom;
const { camelCaseToKebabCase: $11d26a5cd5e96053$var$camelCaseToKebabCase, kebabCaseToCamelCase: $11d26a5cd5e96053$var$kebabCaseToCamelCase } = pm.utils.str;
function $11d26a5cd5e96053$export$2e2bcd8739ae039(popup, popupData) {
    const isVideo = popupData.videoUrl ? true : false;
    if (isVideo) {
        const imageWrapper = $11d26a5cd5e96053$var$findHtmlEl(popup, ".single-image-wrapper");
        const authorEl = $11d26a5cd5e96053$var$findHtmlEl(imageWrapper, ".gallery-author");
        if (authorEl) authorEl.parentElement?.removeChild(authorEl);
        const nicenameEl = $11d26a5cd5e96053$var$findHtmlEl(imageWrapper, ".gallery-instagram");
        if (nicenameEl) nicenameEl.parentElement?.removeChild(nicenameEl);
        const metadataEl = $11d26a5cd5e96053$var$findHtmlEl(imageWrapper, ".gallery-metadata");
        if (metadataEl) metadataEl.parentElement?.removeChild(metadataEl);
        const locationEl = $11d26a5cd5e96053$var$findHtmlEl(imageWrapper, ".gallery-location");
        if (locationEl) locationEl.parentElement?.removeChild(locationEl);
    }
    const awardsContainer = $11d26a5cd5e96053$var$findHtmlEl(popup, ".awards-section .wpbf-container-center.wpbf-medium-2-3");
    if (!popupData.isPhotoAuthor && !popupData.hasDescription) {
        popup.classList.add("no-description");
        if (awardsContainer) awardsContainer.classList.add("wpbf-padding-medium");
    } else {
        popup.classList.remove("no-description");
        if (awardsContainer) awardsContainer.classList.add("wpbf-padding-medium-top");
    }
    const reportButton = $11d26a5cd5e96053$var$findHtmlEl(popup, ".report-photo-button");
    if (reportButton && !popupData.isLoggedIn) reportButton.parentElement?.removeChild(reportButton);
    for(const key in popupData)if (popupData.hasOwnProperty(key)) {
        const value = popupData[key];
        const kebabCaseKey = $11d26a5cd5e96053$var$camelCaseToKebabCase(key);
        $11d26a5cd5e96053$var$renderTextModel(popup, kebabCaseKey, value, false);
        $11d26a5cd5e96053$var$renderTextModel(popup, kebabCaseKey, value, true);
    }
    $11d26a5cd5e96053$var$renderAttrModel(popup, popupData);
    $11d26a5cd5e96053$var$renderAttrModels(popup, popupData);
    $11d26a5cd5e96053$var$renderIfModelValueMatches(popup, popupData);
    $11d26a5cd5e96053$var$renderIfModelIsTrue(popup, popupData);
    $11d26a5cd5e96053$var$renderIfModelIsFalse(popup, popupData);
    $11d26a5cd5e96053$var$renderIfAnyModelsTrue(popup, popupData);
    $11d26a5cd5e96053$var$renderIfAllModelsTrue(popup, popupData);
    $11d26a5cd5e96053$var$renderIfModelEmpty(popup, popupData);
    $11d26a5cd5e96053$var$renderIfModelNotEmpty(popup, popupData);
    $11d26a5cd5e96053$var$addClassIfModelTrue(popup, popupData);
    $11d26a5cd5e96053$var$addClassIfAllModelsTrue(popup, popupData);
}
function $11d26a5cd5e96053$var$renderTextModel(popup, dataKey, dataValue, useInnerHTML) {
    const els = useInnerHTML ? $11d26a5cd5e96053$var$findHtmlEls(popup, `[data-content-model="${dataKey}"]`) : $11d26a5cd5e96053$var$findHtmlEls(popup, `[data-text-model="${dataKey}"]`);
    if (els.length === 0) return;
    if (dataKey === "date") {
        const date = new Date(dataValue);
        dataValue = date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric"
        });
    }
    // Loop using for
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        let content = dataValue;
        if (!content || content === "0") {
            const defaultValue = el.dataset.defaultValue;
            if (defaultValue) content = defaultValue;
        } else {
            if (el.dataset.textPrefix) content = el.dataset.textPrefix + content;
            if (el.dataset.textSuffix) content = content + el.dataset.textSuffix;
        }
        if (useInnerHTML) el.innerHTML = content;
        else if (el instanceof HTMLInputElement) el.value = content;
        else el.textContent = content;
        el.classList.remove("is-waiting");
    }
}
function $11d26a5cd5e96053$var$renderAttrModel(popup, popupData) {
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, `[data-attr-model]`);
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        const modelKey = el.dataset.attrModel;
        if (!modelKey) continue;
        const attrName = el.dataset.attrName;
        if (!attrName) continue;
        const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
        if (dataKey in popupData) el.setAttribute(attrName, popupData[dataKey]);
    }
}
function $11d26a5cd5e96053$var$renderAttrModels(popup, popupData) {
    // The "data-attr-models" contains list of attrName & attrModel pairs.
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, "[data-attr-models]");
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        if (!el.dataset.attrModels) continue;
        const rawData = el.dataset.attrModels;
        // The "dataObj" will be an object containing pairs of attrName & attrModel.
        const dataObj = JSON.parse(rawData);
        // Loop through the object.
        for(const attrName in dataObj){
            if (!dataObj.hasOwnProperty(attrName)) continue;
            const modelKey = dataObj[attrName];
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) el.setAttribute(attrName, popupData[dataKey]);
        }
    }
}
function $11d26a5cd5e96053$var$renderIfModelValueMatches(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataRenderSelector("if-model-key");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        const modelKey = el.dataset.modelKey;
        const modelValue = el.dataset.renderIfModelValue ?? "";
        let shouldRemove = true;
        if (modelKey) {
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) {
                if (popupData[dataKey] === modelValue) shouldRemove = false;
            }
        }
        if (shouldRemove) el.parentElement?.removeChild(el);
    }
    els.forEach((el)=>el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector)));
}
function $11d26a5cd5e96053$var$renderIfModelIsTrue(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataRenderSelector("if-model-true");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        const modelKey = el.dataset.renderIfModelTrue;
        let shouldRemove = true;
        if (modelKey) {
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) {
                if (popupData[dataKey] === true) shouldRemove = false;
            }
        }
        if (shouldRemove) el.parentElement?.removeChild(el);
    }
    els.forEach((el)=>el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector)));
}
function $11d26a5cd5e96053$var$renderIfModelIsFalse(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataRenderSelector("if-model-false");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        const modelKey = el.dataset.renderIfModelFalse;
        let shouldRemove = true;
        if (modelKey) {
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) {
                if (popupData[dataKey] === false) shouldRemove = false;
            }
        }
        if (shouldRemove) el.parentElement?.removeChild(el);
    }
    els.forEach((el)=>el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector)));
}
function $11d26a5cd5e96053$var$renderIfAnyModelsTrue(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataRenderSelector("if-any-models-true");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        // The value of "attrValue" is comma separated string of model keys.
        let attrValue = el.dataset.renderIfAnyModelsTrue;
        attrValue = attrValue ? attrValue.trim() : "";
        // Split the string into array of model keys.
        const modelKeys = attrValue.split(",");
        let shouldRemove = true;
        if (modelKeys.length) // Loop through the array of model keys.
        for(let j = 0; j < modelKeys.length; j++){
            const modelKey = modelKeys[j].trim();
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) // Check if the model key is true.
            {
                if (popupData[dataKey] === true) {
                    shouldRemove = false;
                    break;
                }
            }
        }
        if (shouldRemove) el.parentElement?.removeChild(el);
    }
    els.forEach((el)=>el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector)));
}
function $11d26a5cd5e96053$var$renderIfAllModelsTrue(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataRenderSelector("if-all-models-true");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        // The value of "attrValue" is comma separated string of model keys.
        let attrValue = el.dataset.renderIfAllModelsTrue;
        attrValue = attrValue ? attrValue.trim() : "";
        // Split the string into array of model keys.
        const modelKeys = attrValue.split(",");
        let shouldRemove = true;
        if (modelKeys.length) // Loop through the array of model keys.
        for(let j = 0; j < modelKeys.length; j++){
            const modelKey = modelKeys[j].trim();
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) {
                // Check if the model key is true.
                if (popupData[dataKey] === true) shouldRemove = false;
                else {
                    shouldRemove = true;
                    break;
                }
            }
        }
        if (shouldRemove) el.parentElement?.removeChild(el);
    }
    els.forEach((el)=>el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector)));
}
function $11d26a5cd5e96053$var$renderIfModelEmpty(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataRenderSelector("if-model-empty");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        const modelKey = el.dataset.renderIfModelEmpty;
        let shouldRemove = false;
        if (modelKey) {
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) {
                if (popupData[dataKey]) {
                    if (Array.isArray(popupData[dataKey])) {
                        if (popupData[dataKey].length) shouldRemove = true;
                    } else shouldRemove = true;
                }
            }
        }
        if (shouldRemove) el.parentElement?.removeChild(el);
    }
    els.forEach((el)=>el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector)));
}
function $11d26a5cd5e96053$var$renderIfModelNotEmpty(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataRenderSelector("if-model-not-empty");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        const modelKey = el.dataset.renderIfModelNotEmpty;
        let shouldRemove = true;
        if (modelKey) {
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) {
                if (popupData[dataKey]) {
                    if (Array.isArray(popupData[dataKey])) {
                        if (popupData[dataKey].length) shouldRemove = false;
                    } else shouldRemove = false;
                }
            }
        }
        if (shouldRemove) el.parentElement?.removeChild(el);
    }
    els.forEach((el)=>el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector)));
}
function $11d26a5cd5e96053$var$addClassIfModelTrue(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataAddClassSelector("if-model-true");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    const classToAddAttr = "data-class-to-add";
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        const modelKey = el.dataset.addClassIfModelTrue;
        const className = el.getAttribute(classToAddAttr);
        if (!modelKey || !className) continue;
        const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
        if (dataKey in popupData) {
            if (popupData[dataKey] === true) el.classList.add(className);
        }
    }
    els.forEach((el)=>{
        el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector));
        el.removeAttribute(classToAddAttr);
    });
}
function $11d26a5cd5e96053$var$addClassIfAllModelsTrue(popup, popupData) {
    const selector = $11d26a5cd5e96053$var$makeDataAddClassSelector("if-all-models-true");
    const els = $11d26a5cd5e96053$var$findHtmlEls(popup, selector);
    if (els.length === 0) return;
    const classToAddAttr = "data-class-to-add";
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        // The value of "attrValue" is comma separated string of model keys.
        let attrValue = el.dataset.addClassIfAllModelsTrue;
        attrValue = attrValue ? attrValue.trim() : "";
        // Split the string into array of model keys.
        const modelKeys = attrValue.split(",");
        if (modelKeys.length === 0) continue;
        let shouldAddClass = false;
        // Loop through the array of model keys.
        for(let j = 0; j < modelKeys.length; j++){
            const modelKey = modelKeys[j].trim();
            const dataKey = $11d26a5cd5e96053$var$kebabCaseToCamelCase(modelKey);
            if (dataKey in popupData) {
                // Check if the model key is true.
                if (popupData[dataKey] === true) shouldAddClass = true;
                else {
                    shouldAddClass = false;
                    break;
                }
            }
        }
        if (shouldAddClass) {
            const classToAdd = el.getAttribute(classToAddAttr);
            if (classToAdd) el.classList.add(classToAdd);
        }
    }
    els.forEach((el)=>{
        el.removeAttribute($11d26a5cd5e96053$var$dataSelectorToAttr(selector));
        el.removeAttribute(classToAddAttr);
    });
}
function $11d26a5cd5e96053$var$makeDataRenderSelector(key) {
    return `[data-render-${key}]`;
}
function $11d26a5cd5e96053$var$makeDataAddClassSelector(key) {
    return `[data-add-class-${key}]`;
}
function $11d26a5cd5e96053$var$dataSelectorToAttr(selector) {
    return selector.replace("[", "").replace("]", "");
}


function $9183cee1bfe3ef96$export$e503de0ce3521c74(photoId, gridPhotoWrapper, gridPhoto) {
    const { findHtmlEl: findHtmlEl } = pm.utils.dom;
    const gridItem = gridPhotoWrapper.parentElement;
    const authorDataEl = findHtmlEl(gridPhotoWrapper, ".gallery-author");
    const rawCaptionOriginEl = findHtmlEl(gridPhotoWrapper, ".raw-photo-caption");
    const originLocationEl = findHtmlEl(gridPhotoWrapper, ".gallery-location");
    const galleryMetaDataSelector = ".gallery-metadata";
    const originApertureEl = findHtmlEl(gridPhotoWrapper, galleryMetaDataSelector + " .aperture");
    const originShutterSpeedEl = findHtmlEl(gridPhotoWrapper, galleryMetaDataSelector + " .shutter-speed");
    const originIsoEl = findHtmlEl(gridPhotoWrapper, galleryMetaDataSelector + " .iso");
    let categoryIdsAttrVal = gridPhotoWrapper.dataset.categoryIds;
    categoryIdsAttrVal = categoryIdsAttrVal ? categoryIdsAttrVal.trim() : "";
    let categoryIds = [];
    if (categoryIdsAttrVal) {
        const splits = categoryIdsAttrVal.split(",");
        if (splits.length) // Loop through splits and push the value to categoryIds.
        for(let i = 0; i < splits.length; i++){
            const categoryId = parseInt(splits[i], 10);
            if (categoryId) categoryIds.push(categoryId);
        }
    }
    const photoWidthRawVal = gridPhoto.getAttribute("width");
    const photoHeightRawVal = gridPhoto.getAttribute("height");
    let videoUrl = gridPhotoWrapper.dataset.videoUrl ?? "";
    videoUrl = videoUrl ? videoUrl + "?autoplay=1&rel=0" : "";
    const isVideo = videoUrl ? true : false;
    return {
        id: photoId,
        postName: "",
        date: gridPhotoWrapper.dataset.publishedDate ?? "",
        description: rawCaptionOriginEl ? rawCaptionOriginEl.innerHTML : "",
        attachmentUrl: gridPhotoWrapper.dataset.attachmentUrl ?? "",
        authorId: authorDataEl && authorDataEl.dataset.authorId ? parseInt(authorDataEl.dataset.authorId, 10) : 0,
        authorNicename: authorDataEl && authorDataEl.dataset.authorNicename ? authorDataEl.dataset.authorNicename : "",
        authorDisplayName: authorDataEl && authorDataEl.dataset.authorDisplayName ? authorDataEl.dataset.authorDisplayName : "",
        authorProfileUrl: authorDataEl && authorDataEl.dataset.authorProfileUrl ? authorDataEl.dataset.authorProfileUrl : "",
        authorAvatarUrl: authorDataEl && authorDataEl.dataset.authorAvatarUrl ? authorDataEl.dataset.authorAvatarUrl : "",
        authorMembershipType: authorDataEl && authorDataEl.dataset.authorMembershipType ? authorDataEl.dataset.authorMembershipType : "",
        potd: gridPhoto.classList.contains("assigned-to-potd"),
        potm: gridPhoto.classList.contains("is-potm"),
        featured: gridPhoto.classList.contains("is-featured"),
        address: originLocationEl && !isVideo ? originLocationEl.innerHTML : "",
        album: "",
        imageTitle: gridPhoto.alt,
        aperture: originApertureEl ? originApertureEl.innerHTML : "",
        shutterSpeed: originShutterSpeedEl ? originShutterSpeedEl.innerHTML : "",
        iso: originIsoEl ? originIsoEl.innerHTML : "",
        camera: gridPhotoWrapper.dataset.camera ?? "",
        cameraSlug: gridPhotoWrapper.dataset.cameraSlug ?? "",
        cameraUrl: gridPhotoWrapper.dataset.cameraUrl ?? "",
        cameraAlias: gridPhotoWrapper.dataset.cameraAlias ?? "",
        focalLength: gridPhotoWrapper.dataset.focalLength ?? "",
        editableCamera: !!gridPhotoWrapper.dataset.editableCamera,
        editableFocalLength: !!gridPhotoWrapper.dataset.editableFocalLength,
        url: gridPhoto.src,
        width: photoWidthRawVal ? parseInt(photoWidthRawVal, 10) : 0,
        height: photoHeightRawVal ? parseInt(photoHeightRawVal, 10) : 0,
        urlLarge: gridPhotoWrapper.dataset.largeUrl ?? "",
        totalLikes: gridPhotoWrapper.dataset.totalLikes ? parseInt(gridPhotoWrapper.dataset.totalLikes, 10) : 0,
        totalComments: 0,
        isLiked: gridPhoto.classList.contains("is-liked"),
        categories: categoryIds,
        adId: gridItem?.dataset.spcId ? parseInt(gridItem.dataset.spcId, 10) : 0,
        needsFeedback: !!gridPhotoWrapper.dataset.needsFeedback,
        videoUrl: videoUrl
    };
}


function $3d1beee2f4243215$export$2e2bcd8739ae039(popup, photoData) {
    if (pm.currentUser.id !== photoData.authorId) return;
    const targets = popup.querySelectorAll(".inline-editing");
    if (!targets.length) return;
    const photoId = photoData.id;
    for(let i = 0; i < targets.length; i++){
        const target = targets[i];
        const contentType = target.dataset.contentType;
        if (contentType !== "photo_description" && contentType !== "photo_camera" && contentType !== "photo_focal_length") continue;
        const gridImageWrapperSelector = `.grid-image-wrapper[data-photo-id="${photoId}"]`;
        switch(contentType){
            case "photo_description":
                target.dataset.syncEditorTo = `${gridImageWrapperSelector} .raw-photo-caption`;
                target.dataset.syncOutputTo = `${gridImageWrapperSelector} .photo-caption`;
                break;
            case "photo_camera":
                target.dataset.syncOutputTo = gridImageWrapperSelector;
                target.dataset.syncToAttr = "data-camera";
                break;
            case "photo_focal_length":
                target.dataset.syncOutputTo = gridImageWrapperSelector;
                target.dataset.syncToAttr = "data-focal-length";
                break;
        }
    }
}





function $c270b29052642163$export$2e2bcd8739ae039(area, renderFn) {
    const form = area.querySelector(".ajax-comment-form");
    if (!form) return;
    const textarea = form.querySelector("textarea");
    if (!textarea) return;
    const submitButton = form.querySelector(".submit-button");
    if (!submitButton) return;
    const postId = form.dataset.postId ? parseInt(form.dataset.postId) : 0;
    if (!postId) return;
    const parentField = form.querySelector("[name='comment_parent']");
    let doingAjax = false;
    form.addEventListener("submit", handleFormSubmit);
    async function handleFormSubmit(e) {
        e.preventDefault();
        if (!textarea) return;
        if (!textarea.value) return;
        await submit();
    }
    async function submit() {
        if (doingAjax) return;
        doingAjax = true;
        (0, $2e33a4f4aeb13ba1$export$fea330ef6103f535)(submitButton);
        const parentId = parentField ? parseInt(parentField.value) : 0;
        const response = await (0, $082fa2eaa5a44d4a$export$91a3bff937566879)({
            action: "pm_submit_comment",
            nonce: form.dataset.submitCommentNonce ? form.dataset.submitCommentNonce : "",
            postId: postId,
            parentId: parentId,
            content: textarea.value
        });
        if (!response.success) alert(response.message);
        else {
            textarea.value = "";
            renderFn(postId, parentId, response.data);
        }
        doingAjax = false;
        (0, $2e33a4f4aeb13ba1$export$4dabcd056c1d895c)(submitButton);
    }
}


const { findHtmlEl: $624dba11e5cc0671$var$findHtmlEl, findHtmlEls: $624dba11e5cc0671$var$findHtmlEls } = pm.utils.dom;
function $624dba11e5cc0671$export$2e2bcd8739ae039(commentListWrapper, commentListItem, popupCommentData) {
    commentListItem.classList.add("comment-list-item");
    const isLoggedIn = popupCommentData.isLoggedIn;
    const isCommentAuthor = popupCommentData.isCommentAuthor;
    $624dba11e5cc0671$var$renderByLoginState(commentListItem, true, isLoggedIn);
    $624dba11e5cc0671$var$renderByLoginState(commentListItem, false, isLoggedIn);
    $624dba11e5cc0671$var$renderIfCommentAuthor(commentListItem, isCommentAuthor);
    $624dba11e5cc0671$var$renderIfNotCommentAuthor(commentListItem, isCommentAuthor);
    $624dba11e5cc0671$var$renderTemplateTags(commentListItem, popupCommentData);
    $624dba11e5cc0671$var$parseIsLiked(commentListItem, popupCommentData.commentIsLiked);
    $624dba11e5cc0671$var$parseTotalLikes(commentListItem, popupCommentData.commentTotalLikes);
    commentListItem.classList.remove("is-hidden");
    commentListWrapper.appendChild(commentListItem);
}
function $624dba11e5cc0671$var$renderByLoginState(area, shouldLogin, isCurrentlyLoggedIn) {
    const els = shouldLogin ? $624dba11e5cc0671$var$findHtmlEls(area, "[data-render-if-is-logged-in]") : $624dba11e5cc0671$var$findHtmlEls(area, "[data-render-if-not-logged-in]");
    if (!els.length) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        if (shouldLogin && !isCurrentlyLoggedIn) el.parentNode.removeChild(el);
        else if (!shouldLogin && isCurrentlyLoggedIn) el.parentNode.removeChild(el);
    }
}
function $624dba11e5cc0671$var$renderIfCommentAuthor(area, isCommentAuthor) {
    const els = $624dba11e5cc0671$var$findHtmlEls(area, "[data-render-if-comment-author]");
    if (!els.length) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        if (!isCommentAuthor) el.parentNode.removeChild(el);
    }
}
function $624dba11e5cc0671$var$renderIfNotCommentAuthor(area, isCommentAuthor) {
    const els = $624dba11e5cc0671$var$findHtmlEls(area, "[data-render-if-not-comment-author]");
    if (!els.length) return;
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        if (isCommentAuthor) el.parentNode.removeChild(el);
    }
}
function $624dba11e5cc0671$var$renderTemplateTags(area, data) {
    $624dba11e5cc0671$var$renderTemplateTagsForAttr(area, data);
    const elsFromAttr = $624dba11e5cc0671$var$findHtmlEls(area, "[data-attr-has-template-tags]");
    if (elsFromAttr.length) for(let i = 0; i < elsFromAttr.length; i++){
        const el = elsFromAttr[i];
        $624dba11e5cc0671$var$renderTemplateTagsForAttr(el, data);
    }
    const elsFromText = $624dba11e5cc0671$var$findHtmlEls(area, "[data-text-has-template-tags]");
    if (elsFromText.length) for(let i = 0; i < elsFromText.length; i++){
        const el = elsFromText[i];
        $624dba11e5cc0671$var$renderTemplateTagsForContent(el, data, false);
    }
    const elsFromContent = $624dba11e5cc0671$var$findHtmlEls(area, "[data-content-has-template-tags]");
    if (elsFromContent.length) for(let i = 0; i < elsFromContent.length; i++){
        const el = elsFromContent[i];
        $624dba11e5cc0671$var$renderTemplateTagsForContent(el, data, true);
    }
}
const $624dba11e5cc0671$var$attributesToParse = [
    "id",
    "class",
    "href",
    "src"
];
function $624dba11e5cc0671$var$renderTemplateTagsForAttr(el, data) {
    for(let i = 0; i < $624dba11e5cc0671$var$attributesToParse.length; i++){
        const attr = $624dba11e5cc0671$var$attributesToParse[i];
        if (el.hasAttribute(attr)) {
            const attrName = el.getAttribute(attr);
            if (attrName) {
                const attrContent = $624dba11e5cc0671$var$parseTemplateTags(attrName, data);
                if (attrContent) el.setAttribute(attr, attrContent);
            }
        }
    }
    const datasets = el.dataset;
    for(const key in datasets)if (datasets.hasOwnProperty(key)) {
        const value = datasets[key];
        if (value) el.dataset[key] = $624dba11e5cc0671$var$parseTemplateTags(value, data);
    }
}
function $624dba11e5cc0671$var$renderTemplateTagsForContent(el, data, useInnerHTML) {
    let content = useInnerHTML ? el.innerHTML : el.textContent;
    if (content) {
        content = $624dba11e5cc0671$var$parseTemplateTags(content, data);
        el.innerHTML = content;
    }
}
function $624dba11e5cc0671$var$parseTemplateTags(content, data) {
    if (!content) return content;
    let parsed = content;
    // Loop through data and replace the tags with the data.
    for(const key in data)if (data.hasOwnProperty(key)) {
        // @ts-ignore
        const value = data[key];
        const kebabCasedKey = pm.utils.str.camelCaseToKebabCase(key);
        parsed = parsed.replace(`{${kebabCasedKey}}`, value);
    }
    return parsed;
}
function $624dba11e5cc0671$var$parseIsLiked(commentListItem, isLiked) {
    const likeButton = $624dba11e5cc0671$var$findHtmlEl(commentListItem, ".like-button.like-comment");
    if (likeButton) {
        if (isLiked) likeButton.classList.add("is-liked");
        else likeButton.classList.remove("is-liked");
        const svgTitleEl = $624dba11e5cc0671$var$findHtmlEl(likeButton, "svg title");
        if (svgTitleEl) {
            const likedTitle = likeButton.dataset.likedTitle ? likeButton.dataset.likedTitle : "";
            const unlikedTitle = likeButton.dataset.unlikedTitle ? likeButton.dataset.unlikedTitle : "";
            svgTitleEl.innerHTML = isLiked ? likedTitle : unlikedTitle;
        }
    }
}
function $624dba11e5cc0671$var$parseTotalLikes(commentListItem, totalLikes) {
    const totalLikesEl = $624dba11e5cc0671$var$findHtmlEl(commentListItem, ".comment-likes .total-likes");
    if (totalLikesEl) {
        totalLikesEl.textContent = totalLikes.toString();
        if (totalLikes) totalLikesEl.classList.remove("is-hidden");
        else totalLikesEl.classList.add("is-hidden");
    }
}


const { findHtmlEl: $998b0c568d7d72ec$var$findHtmlEl } = pm.utils.dom;
async function $998b0c568d7d72ec$export$2e2bcd8739ae039(popup, photoData, commentListItemToClone) {
    const commentsSection = $998b0c568d7d72ec$var$findHtmlEl(popup, ".commentlist");
    if (!commentsSection) return;
    const commentListWrapper = $998b0c568d7d72ec$var$findHtmlEl(commentsSection, ".comments");
    if (!commentListWrapper) return;
    const commentsTitleEl = $998b0c568d7d72ec$var$findHtmlEl(popup, "#comments-title");
    if (!commentsTitleEl) return;
    const response = await (0, $082fa2eaa5a44d4a$export$f849cc6a5aab7628)({
        action: "pm_fetch_all_comments",
        nonce: popup.dataset.fetchCommentsNonce ? popup.dataset.fetchCommentsNonce : "",
        photoId: photoData.id
    });
    let commentList = [];
    if (!response.success) commentsTitleEl.innerHTML = response.message ? response.message : "";
    else commentList = response.data;
    if (commentList.length) // Loop through the comments and render them.
    for (const comment of commentList)$998b0c568d7d72ec$var$renderCommentListItem(popup, commentListWrapper, photoData, comment, commentListItemToClone, 1);
    commentsSection.appendChild(commentListWrapper);
    window.addComment?.init?.(commentsSection);
    renderCommentsCount(countTotalCommentItems(commentList));
    (0, $c270b29052642163$export$2e2bcd8739ae039)(popup, handleOnCommentAdded);
    commentsSection.classList.remove("is-hidden");
    function renderCommentsCount(totalComments) {
        const commentsCount = $998b0c568d7d72ec$var$findHtmlEl(popup, ".comments-count");
        if (!commentsCount) return;
        commentsCount.textContent = totalComments.toString();
        const commentsTitle = commentsCount.parentElement;
        if (!totalComments) commentsTitle?.classList.add("is-hidden");
        else commentsTitle?.classList.remove("is-hidden");
    }
    function countTotalCommentItems(commentList) {
        let totalCount = 0;
        for (const item of commentList){
            totalCount++; // Count the current item
            if (item.children && item.children.length > 0) // Count nested items if any, recursively
            totalCount += countTotalCommentItems(item.children);
        }
        return totalCount;
    }
    function handleOnCommentAdded(postId, parentId, responseData) {
        if (parentId) {
            const respond = $998b0c568d7d72ec$var$findHtmlEl(popup, ".comment-respond");
            if (respond) // Move respond element to be after a section with "commentlist" class using insertBefore.
            commentListWrapper.parentNode?.insertBefore(respond, commentListWrapper.nextElementSibling);
        }
        pm.utils.dom.emptyElement(commentListWrapper);
        renderCommentsCount(countTotalCommentItems(responseData.commentList));
        if (!responseData.commentList.length) return;
        // Loop through the comments and render them.
        for (const comment of responseData.commentList)$998b0c568d7d72ec$var$renderCommentListItem(popup, commentListWrapper, photoData, comment, commentListItemToClone, 1);
        if (parentId) // Move the div with id "respond" to the initial place which is after a section with class "commentlist".
        window?.addComment?.moveForm?.(`comment-${parentId}`, parentId, "respond", postId, undefined);
    }
}
function $998b0c568d7d72ec$var$renderCommentListItem(popup, commentListWrapper, photoData, commentData, itemToClone, depth) {
    const isCommentAuthor = pm.currentUser.isLoggedIn && commentData.authorId === pm.currentUser.id;
    const commentDate = new Date(commentData.dateGmt);
    const formattedDate = commentDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
    const popupCommentData = {
        commentReportingNonce: popup.dataset.reportCommentNonce ? popup.dataset.reportCommentNonce : "",
        loginUrl: pm.loginUrl,
        photoAttachmentUrl: photoData.attachmentUrl,
        photoId: photoData.id,
        isLoggedIn: pm.currentUser.isLoggedIn,
        isCommentAuthor: isCommentAuthor,
        inlineEditingClass: isCommentAuthor ? "inline-editing" : "",
        isEditableClass: isCommentAuthor ? "is-content-editable" : "",
        commentId: commentData.id,
        commentDate: commentData.date,
        commentDateGmt: commentData.dateGmt,
        commentFormattedDate: formattedDate,
        commentAuthorId: commentData.authorId,
        commentAuthorNicename: commentData.authorNicename,
        commentAuthorDisplayName: commentData.authorDisplayName,
        commentAuthorProfileUrl: commentData.authorProfileUrl,
        commentAuthorAvatarUrl: commentData.authorAvatarUrl,
        commentAuthorMembershipType: "",
        commentContent: commentData.content,
        commentFormattedContent: pm.utils.str.wpautop(commentData.content, true),
        commentIsLiked: commentData.isLiked,
        commentTotalLikes: commentData.totalLikes
    };
    const commentListItemEl = itemToClone.cloneNode(true);
    if (depth && depth > 2) {
        const replyLink = $998b0c568d7d72ec$var$findHtmlEl(commentListItemEl, ".comment-reply-link");
        if (replyLink) // Remove the Reply link.
        replyLink.parentNode?.removeChild(replyLink);
    }
    const commentArticle = $998b0c568d7d72ec$var$findHtmlEl(commentListItemEl, "article.comment");
    if (commentArticle) {
        commentArticle.classList.remove("depth-1");
        commentArticle.classList.add(`depth-${depth}`);
    }
    (0, $624dba11e5cc0671$export$2e2bcd8739ae039)(commentListWrapper, commentListItemEl, popupCommentData);
    if (commentData.children.length > 0) for (const childComment of commentData.children){
        // Create ul element for the children.
        const childrenListEl = document.createElement("ul");
        childrenListEl.classList.add("children");
        $998b0c568d7d72ec$var$renderCommentListItem(popup, childrenListEl, photoData, childComment, itemToClone, (depth ? depth : 1) + 1);
        commentListItemEl.appendChild(childrenListEl);
    }
}


const $f701c8e2633e7414$export$534a72f6c985c7fc = (area)=>{
    const { getClosest: getClosest } = pm.utils.dom;
    init();
    let fadingTimeoutId = null;
    function init() {
        area.addEventListener("mousemove", handleOverlayMousemove);
    }
    function handleOverlayMousemove(e) {
        const target = e.target;
        if (!target) return;
        const imageWrapper = getClosest(target, ".single-image-wrapper");
        if (!imageWrapper) return;
        switchMetaDataFading();
    }
    const metadataSelectors = ".single-image-wrapper .gallery-metadata, .single-image-wrapper .gallery-author, .single-image-wrapper .gallery-instagram, .single-image-wrapper .gallery-location";
    /**
   * Switch meta data fading.
   */ function switchMetaDataFading() {
        jQuery(metadataSelectors).fadeIn("200");
        if (null != fadingTimeoutId) clearTimeout(fadingTimeoutId);
        fadingTimeoutId = window.setTimeout(hidePopupMetaData, 1500);
    }
    /**
   * Hide popup meta data.
   */ function hidePopupMetaData() {
        jQuery(metadataSelectors).fadeOut("200");
    }
};


function $6d03589822de7955$export$2e2bcd8739ae039(popup, photoData) {
    const { findHtmlEl: findHtmlEl } = pm.utils.dom;
    const popupPhotoWrapper = findHtmlEl(popup, ".single-image-wrapper");
    if (!popupPhotoWrapper) return;
    // const popupPhotoWrapperHeight = popupPhotoWrapper
    // 	? getPureInnerHeight(popupPhotoWrapper)
    // 	: 0;
    const isVideo = photoData.videoUrl ? true : false;
    const popupPhoto = findHtmlEl(popup, ".single-image");
    if (isVideo) {
        if (popupPhoto) {
            const iframeWidth = popupPhoto.clientWidth;
            // Calculate using 16:9 ratio.
            const iframeHeight = iframeWidth * 0.5625;
            popupPhoto.style.height = iframeHeight + "px";
            popupPhotoWrapper.classList.add("height-auto");
            popupPhotoWrapper.style.width = iframeWidth + "px";
        }
    } else {
        const photoWidth = photoData.width;
        const photoHeight = photoData.height;
        const popupPhotoWrapperHeight = window.innerHeight - 270;
        const heightRatio = popupPhotoWrapperHeight / photoHeight;
        const calculatedPopupPhotoWrapperWidth = Math.round(photoWidth * heightRatio);
        if (photoWidth >= photoHeight) {
            popupPhotoWrapper.style.width = calculatedPopupPhotoWrapperWidth + "px";
            popupPhotoWrapper.classList.add("height-auto");
            if (popupPhoto && !isVideo) popupPhoto.style.height = "auto";
        } else {
            popupPhotoWrapper.style.width = "auto";
            const renderedPopupPhotoWrapperWidth = popupPhotoWrapper.clientWidth;
            if (renderedPopupPhotoWrapperWidth < calculatedPopupPhotoWrapperWidth) {
                popupPhotoWrapper.style.width = renderedPopupPhotoWrapperWidth + "px";
                popupPhotoWrapper.classList.add("height-auto");
            } else {
                popupPhotoWrapper.style.width = calculatedPopupPhotoWrapperWidth + "px";
                popupPhotoWrapper.classList.remove("height-auto");
            }
        }
    }
}


function $0309b0dd50b19d82$export$2e2bcd8739ae039(popup, photoData) {
    const { findHtmlEl: findHtmlEl } = pm.utils.dom;
    const shimmer = findHtmlEl(popup, ".loading-shimmer");
    if (!shimmer) return;
    const photoWrapper = findHtmlEl(popup, ".single-image-wrapper");
    if (!photoWrapper) return;
    const shimmerHeight = $0309b0dd50b19d82$var$calculateShimmerHeight(photoWrapper, photoData.width, photoData.height);
    shimmer.style.height = shimmerHeight + "px";
}
function $0309b0dd50b19d82$var$calculateShimmerHeight(photoWrapper, photoWidth, photoHeight) {
    const photoWrapperWidth = photoWrapper.offsetWidth;
    const widthRatio = photoWrapperWidth / photoWidth;
    return photoHeight * widthRatio;
}


function $5b8e30c7af6dcecb$export$2e2bcd8739ae039(popup, photoData, gridPhotoWrapper) {
    const { findHtmlEl: findHtmlEl } = pm.utils.dom;
    const captionOriginEl = findHtmlEl(gridPhotoWrapper, ".photo-caption");
    return {
        photoReportingNonce: popup.dataset.reportPhotoNonce ? popup.dataset.reportPhotoNonce : "",
        isPhotoAuthor: photoData.authorId === pm.currentUser.id,
        isLoggedIn: pm.currentUser.isLoggedIn,
        photoId: photoData.id,
        id: photoData.id,
        postId: photoData.id,
        date: photoData.date,
        hasDescription: !!photoData.description,
        description: photoData.description,
        formattedDescription: captionOriginEl ? captionOriginEl.innerHTML : photoData.description,
        attachmentUrl: photoData.attachmentUrl,
        authorId: photoData.authorId,
        authorNicename: photoData.authorNicename,
        authorDisplayName: photoData.authorDisplayName,
        authorProfileUrl: photoData.authorProfileUrl,
        authorAvatarUrl: photoData.authorAvatarUrl,
        authorMembershipType: photoData.authorMembershipType,
        potd: photoData.potd,
        featured: photoData.featured,
        address: photoData.address,
        album: photoData.album,
        imageTitle: photoData.imageTitle,
        aperture: photoData.aperture,
        shutterSpeed: photoData.shutterSpeed,
        iso: photoData.iso,
        camera: photoData.camera,
        cameraSlug: photoData.cameraSlug,
        cameraUrl: photoData.cameraUrl,
        cameraAlias: photoData.cameraAlias,
        focalLength: photoData.focalLength,
        editableCamera: photoData.editableCamera,
        editableFocalLength: photoData.editableFocalLength,
        url: photoData.url,
        urlLarge: photoData.urlLarge,
        isLiked: photoData.isLiked,
        categories: photoData.categories,
        videoUrl: photoData.videoUrl
    };
}


const { findHtmlEl: $100925dc27e05de3$var$findHtmlEl, findHtmlEls: $100925dc27e05de3$var$findHtmlEls, findImgEl: $100925dc27e05de3$var$findImgEl, getClosest: $100925dc27e05de3$var$getClosest, emptyElement: $100925dc27e05de3$var$emptyElement } = pm.utils.dom;
const $100925dc27e05de3$var$popupClassName = "photo-popup";
const $100925dc27e05de3$var$overlayClassName = $100925dc27e05de3$var$popupClassName + "-overlay";
const $100925dc27e05de3$var$openedClassName = "has-" + $100925dc27e05de3$var$popupClassName + "-opened";
const $100925dc27e05de3$var$triggerClassName = $100925dc27e05de3$var$popupClassName + "-trigger";
const $100925dc27e05de3$var$popupSelector = "." + $100925dc27e05de3$var$popupClassName;
const $100925dc27e05de3$var$overlaySelector = "." + $100925dc27e05de3$var$overlayClassName;
const $100925dc27e05de3$var$triggerSelector = "." + $100925dc27e05de3$var$triggerClassName;
const $100925dc27e05de3$var$gridImageClassName = "grid-image";
const $100925dc27e05de3$var$gridImageSelector = "." + $100925dc27e05de3$var$gridImageClassName;
const $100925dc27e05de3$var$gridImgWrapperClassName = $100925dc27e05de3$var$gridImageClassName + "-wrapper";
const $100925dc27e05de3$var$gridImgWrapperSelector = "." + $100925dc27e05de3$var$gridImgWrapperClassName;
/**
 * The popup overlay element.
 *
 * @var HTMLElement
 */ const $100925dc27e05de3$var$overlay = $100925dc27e05de3$var$findHtmlEl($100925dc27e05de3$var$overlaySelector);
/**
 * The last history state id.
 *
 * @var number
 */ let $100925dc27e05de3$var$lastStateId = 0;
/**
 * Whether to force go back or not.
 *
 * @var boolean
 */ let $100925dc27e05de3$var$forceGoBack = false;
const $100925dc27e05de3$var$$overlay = jQuery($100925dc27e05de3$var$overlaySelector);
function $100925dc27e05de3$var$generateStateId() {
    return new Date().getTime();
}
const $100925dc27e05de3$var$popupMarkupToClone = $100925dc27e05de3$var$findHtmlEl($100925dc27e05de3$var$popupSelector);
const $100925dc27e05de3$var$prevNavButton = $100925dc27e05de3$var$findHtmlEl(".popup-prev-button");
const $100925dc27e05de3$var$nextNavButton = $100925dc27e05de3$var$findHtmlEl(".popup-next-button");
const $100925dc27e05de3$var$popupToClone = $100925dc27e05de3$var$popupMarkupToClone?.cloneNode(true);
const $100925dc27e05de3$var$commentListItemMarkupToClone = $100925dc27e05de3$var$popupToClone ? $100925dc27e05de3$var$findHtmlEl($100925dc27e05de3$var$popupToClone, ".comment-list-item") : null;
const $100925dc27e05de3$var$commentListItemToClone = $100925dc27e05de3$var$commentListItemMarkupToClone?.cloneNode(true);
if ($100925dc27e05de3$var$commentListItemMarkupToClone) // Remove the markup (that was for cloning purpose) from the DOM.
$100925dc27e05de3$var$commentListItemMarkupToClone.parentNode?.removeChild($100925dc27e05de3$var$commentListItemMarkupToClone);
if ($100925dc27e05de3$var$popupMarkupToClone) // Remove the markup (that was for cloning purpose) from the DOM.
$100925dc27e05de3$var$popupMarkupToClone.parentNode?.removeChild($100925dc27e05de3$var$popupMarkupToClone);
function $100925dc27e05de3$export$2e2bcd8739ae039() {
    let predefinedData = null;
    let clickTrigger = null;
    let popup = null;
    let photoData = null;
    let popupData = null;
    let gridPhoto = null;
    let gridPhotoWrapper = null;
    let nextDisabled = false;
    let prevDisabled = false;
    function resetPopupData() {
        predefinedData = null;
        clickTrigger = null;
        popup = null;
        photoData = null;
        popupData = null;
        gridPhoto = null;
        gridPhotoWrapper = null;
        nextDisabled = false;
        prevDisabled = false;
    }
    init();
    function init() {
        if (!$100925dc27e05de3$var$overlay || !$100925dc27e05de3$var$popupToClone || !$100925dc27e05de3$var$commentListItemToClone) return;
        const initialStateId = $100925dc27e05de3$var$generateStateId();
        window.history.replaceState({
            stateId: initialStateId,
            currentUrl: window.location.href
        }, "", window.location.href);
        $100925dc27e05de3$var$lastStateId = initialStateId;
        document.addEventListener("DOMContentLoaded", handleDocumentReady);
        document.addEventListener("click", handleDocumentClick);
        document.addEventListener("keyup", handleDocumentKeyUp);
        window.addEventListener("popstate", handleWindowPopState);
        window.addEventListener("resize", handleWindowResize);
        if ($100925dc27e05de3$var$prevNavButton) $100925dc27e05de3$var$prevNavButton.addEventListener("click", handlePrevButtonClick);
        if ($100925dc27e05de3$var$nextNavButton) $100925dc27e05de3$var$nextNavButton.addEventListener("click", handleNextButtonClick);
        if ($100925dc27e05de3$var$overlay) {
            $100925dc27e05de3$var$overlay.addEventListener("click", closePopupOnOverlayClick);
            (0, $f701c8e2633e7414$export$534a72f6c985c7fc)($100925dc27e05de3$var$overlay);
        }
    }
    function isPopupOpened() {
        return document.body.classList.contains($100925dc27e05de3$var$openedClassName);
    }
    function handlePrevButtonClick(_e) {
        if (!isPopupOpened()) return;
        handleNextPrev("prev");
    }
    function handleNextButtonClick(_e) {
        if (!isPopupOpened()) return;
        handleNextPrev("next");
    }
    function handleWindowResize(_e) {
        if (!isPopupOpened()) return;
        if (!popup) return;
        if (photoData) (0, $6d03589822de7955$export$2e2bcd8739ae039)(popup, photoData);
        if (photoData) (0, $0309b0dd50b19d82$export$2e2bcd8739ae039)(popup, photoData);
    }
    function handleDocumentReady(_e) {
        const autoOpenEl = $100925dc27e05de3$var$findHtmlEl(".auto-open-photo");
        if (!autoOpenEl) return;
        if (!autoOpenEl.classList.contains($100925dc27e05de3$var$gridImgWrapperClassName)) return;
        gridPhotoWrapper = autoOpenEl;
        gridPhoto = $100925dc27e05de3$var$findImgEl(autoOpenEl, $100925dc27e05de3$var$gridImageSelector);
        if (!gridPhoto) return;
        if (!gridPhoto.classList.contains($100925dc27e05de3$var$triggerClassName)) return;
        clickTrigger = gridPhoto;
        photoData = (0, $9183cee1bfe3ef96$export$e503de0ce3521c74)(getPhotoIdFromDataset(gridPhotoWrapper), gridPhotoWrapper, gridPhoto);
        predefinedData = null;
        popupData = null;
        openPopup();
    }
    function handleDocumentClick(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        clickTrigger = $100925dc27e05de3$var$getClosest(target, $100925dc27e05de3$var$triggerSelector);
        if (!(clickTrigger instanceof HTMLElement)) return;
        if (clickTrigger.tagName.toLowerCase() === "a") e.preventDefault();
        if (clickTrigger.dataset.predefinedPopupData) {
            // @ts-ignore
            predefinedData = window[clickTrigger.dataset.predefinedPopupData];
            photoData = predefinedData ? predefinedData.photoData : null;
            popupData = predefinedData ? predefinedData.popupData : null;
            gridPhoto = null;
            gridPhotoWrapper = null;
        } else if (clickTrigger instanceof HTMLImageElement) {
            predefinedData = null;
            gridPhoto = clickTrigger;
            gridPhotoWrapper = clickTrigger.parentElement;
            if (gridPhotoWrapper) photoData = (0, $9183cee1bfe3ef96$export$e503de0ce3521c74)(getPhotoIdFromDataset(gridPhotoWrapper), gridPhotoWrapper, gridPhoto);
            popupData = null;
        }
        openPopup();
    }
    function getPhotoIdFromDataset(target) {
        return target.dataset.photoId ? parseInt(target.dataset.photoId, 10) : 0;
    }
    function handleDocumentKeyUp(e) {
        if (!e || !e.key) return;
        const key = e.key.toLowerCase();
        if (key === "escape" || key === "esc") closePopupOnEscapeKeyPressed();
        else if (key === "arrowleft" || key === "left" || key === "arrowright" || key === "right") {
            const direction = key === "arrowleft" || key === "left" ? "prev" : "next";
            const target = e.target;
            if (target instanceof Element) {
                // Return if user is typing a comment or doing inline-editing.
                if (target.tagName.toLowerCase() === "textarea" || target.tagName.toLowerCase() === "input") return;
            }
            handleNextPrev(direction);
        }
    }
    function handleWindowPopState(e) {
        const currentStateId = e.state ? e.state.stateId : null;
        if (!currentStateId) {
            if (document.body.classList.contains($100925dc27e05de3$var$openedClassName)) {
                if ($100925dc27e05de3$var$forceGoBack) {
                    window.history.back();
                    return;
                }
            }
            return;
        }
        $100925dc27e05de3$var$forceGoBack = false;
        const direction = currentStateId === $100925dc27e05de3$var$lastStateId ? "none" : currentStateId < $100925dc27e05de3$var$lastStateId ? "back" : "forward";
        $100925dc27e05de3$var$lastStateId = currentStateId;
        if (direction === "none") {
            if (document.body.classList.contains($100925dc27e05de3$var$openedClassName)) // console.log(`The direction is none let's go back one more time`);
            window.history.back();
        }
        if (direction === "back") {
            if (document.body.classList.contains($100925dc27e05de3$var$openedClassName)) {
                // console.log(`The direction is back let's close the popup`);
                closePopup();
                return;
            }
            return;
        }
        const nextPhotoId = e.state && e.state.popupPhotoId ? e.state.popupPhotoId : 0;
        if (!nextPhotoId) return;
        const nextGridPhotoWrapper = $100925dc27e05de3$var$findHtmlEl(`${$100925dc27e05de3$var$gridImgWrapperSelector}[data-photo-id="${nextPhotoId}"]`);
        if (!nextGridPhotoWrapper) return;
        const nextGridPhoto = $100925dc27e05de3$var$findImgEl(nextGridPhotoWrapper, $100925dc27e05de3$var$gridImageSelector);
        if (!nextGridPhoto) return;
        gridPhotoWrapper = nextGridPhotoWrapper;
        gridPhoto = nextGridPhoto;
        photoData = (0, $9183cee1bfe3ef96$export$e503de0ce3521c74)(getPhotoIdFromDataset(gridPhotoWrapper), gridPhotoWrapper, gridPhoto);
        popupData = null;
        openPopupByForwardEvent();
    }
    function openPopupByForwardEvent() {
        $100925dc27e05de3$var$forceGoBack = false;
        const popup = clonePopup();
        document.title = "Loading...";
        $100925dc27e05de3$var$$overlay.stop().css({
            display: "block"
        }).animate({
            opacity: 1
        }, 250, function() {
            document.title = gridPhoto ? gridPhoto.alt + " - " + pm.pageTitle : pm.pageTitle;
            document.body.classList.add($100925dc27e05de3$var$openedClassName);
            if (photoData) (0, $6d03589822de7955$export$2e2bcd8739ae039)(popup, photoData);
            if (photoData) (0, $0309b0dd50b19d82$export$2e2bcd8739ae039)(popup, photoData);
            if ($100925dc27e05de3$var$prevNavButton) $100925dc27e05de3$var$prevNavButton.classList.remove("is-hidden");
            if ($100925dc27e05de3$var$nextNavButton) $100925dc27e05de3$var$nextNavButton.classList.remove("is-hidden");
            popup.style.opacity = "1";
        });
    }
    function openPopup() {
        $100925dc27e05de3$var$forceGoBack = false;
        popup = clonePopup();
        const newStateId = $100925dc27e05de3$var$generateStateId();
        window.history.pushState({
            stateId: newStateId,
            currentUrl: window.location.href,
            popupPhotoId: photoData ? photoData.id : 0
        }, "", photoData ? photoData.attachmentUrl : "");
        $100925dc27e05de3$var$lastStateId = newStateId;
        document.title = "Loading...";
        $100925dc27e05de3$var$$overlay.stop().css({
            display: "block"
        }).animate({
            opacity: 1
        }, 250, function() {
            document.title = gridPhoto ? gridPhoto.alt + " - " + pm.pageTitle : pm.pageTitle;
            document.body.classList.add($100925dc27e05de3$var$openedClassName);
            if (popup && photoData) (0, $6d03589822de7955$export$2e2bcd8739ae039)(popup, photoData);
            if (popup && photoData) (0, $0309b0dd50b19d82$export$2e2bcd8739ae039)(popup, photoData);
            if ($100925dc27e05de3$var$prevNavButton) $100925dc27e05de3$var$prevNavButton.classList.remove("is-hidden");
            if ($100925dc27e05de3$var$nextNavButton) $100925dc27e05de3$var$nextNavButton.classList.remove("is-hidden");
            if (popup) popup.style.opacity = "1";
        });
    }
    function clonePopup() {
        const clonedPopup = $100925dc27e05de3$var$popupToClone.cloneNode(true);
        clonedPopup.dataset.photoId = photoData ? photoData.id.toString() : "";
        clonedPopup.style.opacity = "0";
        const predefinedPopupDataEls = $100925dc27e05de3$var$findHtmlEls(clonedPopup, "[data-predefined-popup-data]");
        if (predefinedPopupDataEls.length) // Loop using for loop.
        for(let i = 0; i < predefinedPopupDataEls.length; i++){
            const predefinedPopupDataEl = predefinedPopupDataEls[i];
            if (clickTrigger && predefinedData) predefinedPopupDataEl.dataset.predefinedPopupData = clickTrigger.dataset.predefinedPopupData;
            else predefinedPopupDataEl.removeAttribute("data-predefined-popup-data");
        }
        if (predefinedData) {
            nextDisabled = true;
            prevDisabled = true;
        } else {
            nextDisabled = false;
            prevDisabled = false;
        }
        if (prevDisabled) disablePrev();
        else enablePrev();
        if (nextDisabled) disableNext();
        else enableNext();
        if (photoData) {
            if (!popupData && gridPhotoWrapper) popupData = (0, $5b8e30c7af6dcecb$export$2e2bcd8739ae039)(clonedPopup, photoData, gridPhotoWrapper);
            const isVideo = photoData.videoUrl ? true : false;
            const popupPhoto = $100925dc27e05de3$var$findImgEl(clonedPopup, "img.single-image");
            const videoIframe = $100925dc27e05de3$var$findHtmlEl(clonedPopup, "iframe.single-image");
            if (isVideo) popupPhoto?.parentElement?.removeChild(popupPhoto);
            else videoIframe?.parentElement?.removeChild(videoIframe);
            const mediaEl = isVideo ? videoIframe : popupPhoto;
            mediaEl?.addEventListener("load", function(_e) {
                handleOnMediaLoad(clonedPopup, mediaEl);
            });
            (0, $11d26a5cd5e96053$export$2e2bcd8739ae039)(clonedPopup, popupData);
            (0, $44088ef06c06c6cd$export$2e2bcd8739ae039)(clonedPopup, photoData.categories);
            (0, $3d1beee2f4243215$export$2e2bcd8739ae039)(clonedPopup, photoData);
            (0, $998b0c568d7d72ec$export$2e2bcd8739ae039)(clonedPopup, photoData, $100925dc27e05de3$var$commentListItemToClone);
        }
        const likeButton = $100925dc27e05de3$var$findHtmlEl(clonedPopup, ".like-photo");
        if (photoData && (likeButton instanceof HTMLAnchorElement || likeButton instanceof HTMLButtonElement)) (0, $c442b09f19ddf753$export$4d9d47d3d2575b2c)(likeButton, photoData.id, photoData.isLiked, photoData.totalLikes);
        $100925dc27e05de3$var$overlay.appendChild(clonedPopup);
        clonedPopup.classList.remove("is-hidden");
        return clonedPopup;
    }
    function disablePrev() {
        if (!$100925dc27e05de3$var$prevNavButton) return;
        $100925dc27e05de3$var$prevNavButton.style.display = "none";
    }
    function disableNext() {
        if (!$100925dc27e05de3$var$nextNavButton) return;
        $100925dc27e05de3$var$nextNavButton.style.display = "none";
    }
    function enablePrev() {
        if (!$100925dc27e05de3$var$prevNavButton) return;
        $100925dc27e05de3$var$prevNavButton.style.display = "block";
    }
    function enableNext() {
        if (!$100925dc27e05de3$var$nextNavButton) return;
        $100925dc27e05de3$var$nextNavButton.style.display = "block";
    }
    function handleOnMediaLoad(popup, mediaEl) {
        const shimmer = $100925dc27e05de3$var$findHtmlEl(popup, ".loading-shimmer");
        if (shimmer) shimmer.classList.add("is-hidden");
        mediaEl.classList.remove("is-loading");
        popup.classList.remove("is-reloading");
    }
    /**
   * Close the popup on overlay click.
   */ function closePopupOnOverlayClick(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        if (!target.classList.contains($100925dc27e05de3$var$overlayClassName)) return;
        $100925dc27e05de3$var$forceGoBack = true;
        window.history.back();
    }
    /**
   * Close the popup on escape key pressed.
   */ function closePopupOnEscapeKeyPressed() {
        if ($100925dc27e05de3$var$findHtmlEl($100925dc27e05de3$var$popupSelector + " .inline-editing.is-editing")) return;
        if (!isPopupOpened()) return;
        $100925dc27e05de3$var$forceGoBack = true;
        window.history.back();
    }
    /**
   * Close the popup.
   */ function closePopup() {
        // Prevent conflict with context menu exit process (or maybe even other processes).
        if (!document.body.classList.contains($100925dc27e05de3$var$openedClassName)) return;
        $100925dc27e05de3$var$forceGoBack = false;
        document.title = pm.pageTitle;
        if ($100925dc27e05de3$var$prevNavButton) $100925dc27e05de3$var$prevNavButton.classList.add("is-hidden");
        if ($100925dc27e05de3$var$nextNavButton) $100925dc27e05de3$var$nextNavButton.classList.add("is-hidden");
        $100925dc27e05de3$var$$overlay.stop().animate({
            opacity: 0
        }, 250, function() {
            $100925dc27e05de3$var$overlay.scrollTo(0, 0);
            $100925dc27e05de3$var$$overlay.empty();
            $100925dc27e05de3$var$overlay.style.display = "none";
            document.body.classList.remove($100925dc27e05de3$var$openedClassName);
            resetPopupData();
        });
    }
    /**
   * Handle arrow key pressed.
   *
   * @param direction Direction of the arrow key pressed (left or right).
   */ function handleNextPrev(direction) {
        if (!document.body.classList.contains($100925dc27e05de3$var$openedClassName)) return;
        if (!popup) return;
        let gridToShow = null;
        if (gridPhotoWrapper) {
            if ("prev" === direction) gridToShow = gridPhotoWrapper.parentElement?.previousElementSibling;
            else gridToShow = gridPhotoWrapper.parentElement?.nextElementSibling;
        }
        if (!(gridToShow instanceof HTMLElement)) return;
        const gridPhotoWrapperToShow = $100925dc27e05de3$var$findHtmlEl(gridToShow, $100925dc27e05de3$var$gridImgWrapperSelector);
        if (!gridPhotoWrapperToShow) return;
        const gridPhotoToShow = $100925dc27e05de3$var$findImgEl(gridPhotoWrapperToShow, $100925dc27e05de3$var$gridImageSelector);
        if (!gridPhotoToShow) return;
        const photoIdToShow = getPhotoIdFromDataset(gridPhotoWrapperToShow);
        if (!photoIdToShow) return;
        gridPhoto = gridPhotoToShow;
        gridPhotoWrapper = gridPhotoWrapperToShow;
        photoData = (0, $9183cee1bfe3ef96$export$e503de0ce3521c74)(photoIdToShow, gridPhotoWrapper, gridPhoto);
        popupData = null;
        replacePopup();
    }
    function replacePopup() {
        popup = clonePopup();
        const newStateId = $100925dc27e05de3$var$generateStateId();
        window.history.replaceState({
            stateId: newStateId,
            currentUrl: window.location.href,
            popupPhotoId: photoData ? photoData.id : 0
        }, "", photoData ? photoData.attachmentUrl : "");
        $100925dc27e05de3$var$lastStateId = newStateId;
        document.title = "Loading...";
        popup.style.opacity = "0";
        $100925dc27e05de3$var$emptyElement($100925dc27e05de3$var$overlay);
        $100925dc27e05de3$var$overlay?.appendChild(popup);
        document.title = gridPhoto ? gridPhoto.alt + " - " + pm.pageTitle : pm.pageTitle;
        if (photoData) (0, $6d03589822de7955$export$2e2bcd8739ae039)(popup, photoData);
        if (photoData) (0, $0309b0dd50b19d82$export$2e2bcd8739ae039)(popup, photoData);
        popup.style.opacity = "1";
    }
}




const $8f6f724662a1acdb$export$fea330ef6103f535 = (imageWrapper)=>{
    if (!imageWrapper) return;
    imageWrapper.classList.add("is-deleting");
    const overlay = imageWrapper.querySelector(".processing-overlay");
    if (!overlay) return;
    overlay.classList.add("is-loading");
};
const $8f6f724662a1acdb$export$4dabcd056c1d895c = (imageWrapper)=>{
    if (!imageWrapper) return;
    imageWrapper?.classList.remove("is-deleting");
    const overlay = imageWrapper.querySelector(".processing-overlay");
    if (!overlay) return;
    overlay.classList.remove("is-loading");
};


const $1fca4c7cd2abc6f7$export$611a8a3c17598af2 = {
    responsive: true,
    breakpointCols: {
        "min-width: 769px": 3,
        "min-width: 481px": 2
    },
    numCols: 3
};
const $1fca4c7cd2abc6f7$export$655ebe330edad5c1 = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    " ",
    "spacebar",
    "delete",
    "backspace",
    "-",
    "_",
    "@",
    ".",
    "/"
];


function $b39e31f00e7f553c$export$2e2bcd8739ae039(photoId, isReview) {
    const { findHtmlEl: findHtmlEl, findImgEl: findImgEl } = pm.utils.dom;
    const isAuthorPage = document.body.classList.contains("author");
    let doingAjax = false;
    const grid = findHtmlEl(".photo-grid");
    if (!grid) return;
    const imageWrapper = findHtmlEl(".grid-image-wrapper[data-photo-id='" + photoId + "']");
    if (!imageWrapper) return;
    if (!confirm("Are you sure you want to delete this photo?")) return;
    if (doingAjax) return;
    doingAjax = true;
    (0, $8f6f724662a1acdb$export$fea330ef6103f535)(imageWrapper);
    const formData = new FormData();
    formData.append("action", "pm_delete_photo");
    formData.append("nonce", pm.nonces.deletePhoto);
    formData.append("photo_id", photoId.toString());
    if (isReview) formData.append("is_review", "1");
    (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
        method: "post",
        url: pm.ajaxurl,
        data: formData
    }).then((response)=>{
        const photo = findImgEl(imageWrapper, ".grid-image");
        if (isAuthorPage) pm.event.emit("pm_album_update_total_photos", {
            albumSlug: photo?.dataset.albumSlug,
            action: "decrease",
            impactAllPhotosAlbum: true
        });
        const parentEl = imageWrapper.parentElement;
        if (parentEl) grid.removeChild(parentEl);
        FlexMasonry.refresh(grid, (0, $1fca4c7cd2abc6f7$export$611a8a3c17598af2));
    }).catch((response)=>{
        const errorMsg = (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response);
        console.error(errorMsg);
    }).then(()=>{
        doingAjax = false;
        (0, $8f6f724662a1acdb$export$4dabcd056c1d895c)(imageWrapper);
    });
}




const $b82bf523941a899b$var$isLoggedIn = document.body.classList.contains("logged-in");
function $b82bf523941a899b$export$2e2bcd8739ae039() {
    const { findHtmlEl: findHtmlEl, findHtmlEls: findHtmlEls, getClosest: getClosest } = pm.utils.dom;
    const alert = pm.utils.alert;
    const imageWrapperSelector = ".grid-image-wrapper";
    let doingAjax = false;
    let insidePopup = false;
    let predefinedPopupData = null;
    init();
    function init() {
        if (!$b82bf523941a899b$var$isLoggedIn) return;
        document.addEventListener("click", handleDocumentClick);
    }
    function handleDocumentClick(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const likeButton = getClosest(target, ".like-photo", 10);
        if (!likeButton) return;
        insidePopup = likeButton.classList.contains("inside-popup");
        if (insidePopup) {
            if (likeButton.dataset.predefinedPopupData) // @ts-ignore
            {
                if (window[likeButton.dataset.predefinedPopupData]) // @ts-ignore
                predefinedPopupData = window[likeButton.dataset.predefinedPopupData];
            }
        }
        let photoId = 0;
        if (likeButton.dataset.photoId) photoId = parseInt(likeButton.dataset.photoId, 10);
        else {
            const parentNode = likeButton.parentElement;
            if (parentNode?.dataset.photoId) photoId = parseInt(parentNode.dataset.photoId, 10);
        }
        if (!photoId) return;
        submit(photoId, likeButton);
    }
    function submit(photoId, button) {
        if (doingAjax) return;
        doingAjax = true;
        const actionType = button.classList.contains("is-active") ? "unlike" : "like";
        const totaLikesEl = findHtmlEl(button, ".total-likes");
        const prevTotalLikes = totaLikesEl && totaLikesEl.textContent ? parseInt(totaLikesEl.textContent, 10) : 0;
        const newTotalLikes = actionType === "like" ? prevTotalLikes + 1 : prevTotalLikes - 1;
        // Let's visually like/unlike the photo even before the ajax request is started.
        if (actionType === "like") like(photoId, newTotalLikes);
        else unlike(photoId, newTotalLikes);
        const formData = new FormData();
        formData.append("action", "pm_save_like_action");
        formData.append("nonce", pm.nonces.likeOrUnlikePhoto);
        formData.append("photo_id", photoId.toString());
        formData.append("action_type", actionType);
        (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
            method: "post",
            url: pm.ajaxurl,
            data: formData
        }).then((response)=>{
            updateLikesCounts(photoId, response.data.data.totalLikes);
        }).catch((response)=>{
            handleFailedRequest(photoId, actionType, button, prevTotalLikes, response);
        }).then(()=>{
            doingAjax = false;
        });
    }
    function like(photoId, totalLikes) {
        const buttons = findHtmlEls('button.like-photo[data-photo-id="' + photoId + '"]');
        if (!buttons.length) return;
        buttons.forEach((button)=>{
            const textSpan = findHtmlEl(button, ".button-text");
            if (textSpan) textSpan.textContent = totalLikes > 1 ? "Likes" : "Like";
            const titleEl = findHtmlEl(button, "title");
            if (titleEl) titleEl.textContent = "Unlike this photo";
            button.classList.add("is-active");
        });
        const photo = findHtmlEl(`${imageWrapperSelector}[data-photo-id="${photoId}"] .grid-image`);
        photo?.classList.add("is-liked");
        if (insidePopup) {
            if (predefinedPopupData) predefinedPopupData.photoData.isLiked = true;
        }
    }
    function unlike(photoId, totalLikes) {
        const buttons = findHtmlEls('button.like-photo[data-photo-id="' + photoId + '"]');
        if (!buttons.length) return;
        buttons.forEach((button)=>{
            const textSpan = findHtmlEl(button, ".button-text");
            if (textSpan) textSpan.textContent = totalLikes > 1 ? "Likes" : "Like";
            const titleEl = findHtmlEl(button, "title");
            if (titleEl) titleEl.textContent = "Like this photo";
            button.classList.remove("is-active");
        });
        const photo = findHtmlEl(`${imageWrapperSelector}[data-photo-id="${photoId}"] .grid-image`);
        photo?.classList.remove("is-liked");
        if (insidePopup) {
            if (predefinedPopupData) predefinedPopupData.photoData.isLiked = false;
        }
    }
    function handleFailedRequest(photoId, actionType, button, totalLikes, response) {
        const errorMsg = (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response);
        console.error(errorMsg);
        alert.show("error", errorMsg);
        if ("like" === actionType) unlike(photoId, totalLikes);
        else like(photoId, totalLikes);
    }
    function updateLikesCounts(photoId, totalLikes) {
        if (insidePopup) {
            if (predefinedPopupData) predefinedPopupData.photoData.totalLikes = totalLikes;
        }
        const totalLikesStr = totalLikes.toString();
        const photoWrappers = findHtmlEls(imageWrapperSelector);
        if (photoWrappers.length) photoWrappers.forEach((photoWrapper)=>{
            photoWrapper.dataset.totalLikes = totalLikesStr;
        });
        const buttons = findHtmlEls('button.like-photo[data-photo-id="' + photoId + '"]');
        if (!buttons.length) return;
        buttons.forEach((button)=>{
            const totalLikesEl = findHtmlEl(button, ".total-likes");
            if (totalLikesEl) {
                totalLikesEl.textContent = totalLikesStr;
                if (totalLikes > 0) totalLikesEl.classList.remove("is-hidden");
                else totalLikesEl.classList.add("is-hidden");
            }
        });
    }
}




function $03c150816e9a7def$export$b25305d7fdb340d7(notice, content, status, usePbfNotice) {
    if (!notice) return;
    notice.textContent = content;
    if (status) {
        if (status === "success") {
            notice.classList.remove("is-failed");
            notice.classList.add("is-success");
            if (usePbfNotice) {
                notice.classList.remove("wpbf-notice-error");
                notice.classList.add("wpbf-notice-success");
            }
        } else if (status === "failed" || status === "error") {
            notice.classList.remove("is-success");
            notice.classList.add("is-failed");
            if (usePbfNotice) {
                notice.classList.remove("wpbf-notice-success");
                notice.classList.add("wpbf-notice-error");
            }
        }
    }
    notice.classList.remove("is-hidden");
}
function $03c150816e9a7def$export$3bddf9505d6a7871(notice, usePbfNotice) {
    if (!notice) return;
    notice.classList.add("is-hidden");
    notice.textContent = "";
    if (usePbfNotice) {
        notice.classList.remove("wpbf-notice-success");
        notice.classList.remove("wpbf-notice-error");
    }
}


const $0571bdbeaa39d5be$var$animationDuration = 250;
const { findHtmlEl: $0571bdbeaa39d5be$var$findHtmlEl, getClosest: $0571bdbeaa39d5be$var$getClosest } = pm.utils.dom;
function $0571bdbeaa39d5be$export$c70811ece640d3a1(name, triggerButton) {
    const popup = $0571bdbeaa39d5be$var$findHtmlEl("." + name + "-popup");
    if (!popup) return;
    pm.event.emit("pm_popup_will_open", {
        name: name,
        popup: popup,
        triggerButton: triggerButton
    });
    const parentEl = popup.parentElement;
    const overlay = parentEl?.classList.contains("popup-overlay") ? parentEl : null;
    // This is necessary because guidelines-popup has 350ms animation duration.
    const duration = overlay?.dataset.animationDuration ? parseInt(overlay.dataset.animationDuration, 10) : $0571bdbeaa39d5be$var$animationDuration;
    if (overlay) {
        overlay.style.display = "flex";
        jQuery(overlay).stop().animate({
            opacity: 1
        }, duration, ()=>{
            pm.openedPopups[name] = Date.now();
        });
        return;
    }
    // If overlay is not found, just show the popup using slideUp effect from bottom of the page to 20px from bottom.
    jQuery(popup).stop().animate({
        bottom: "20px"
    }, // We don't use duration + 100 because all closing animations are in 350ms.
    $0571bdbeaa39d5be$var$animationDuration + 100, ()=>{
        pm.openedPopups[name] = Date.now();
    });
}
function $0571bdbeaa39d5be$export$e6889fb0929ccf91(name) {
    const popup = $0571bdbeaa39d5be$var$findHtmlEl("." + name + "-popup");
    if (!popup) return;
    pm.event.emit("pm_popup_will_close", {
        name: name,
        popup: popup
    });
    const overlay = $0571bdbeaa39d5be$var$findHtmlEl("." + name + "-popup-overlay");
    if (overlay) {
        jQuery(overlay).stop().animate({
            opacity: 0
        }, $0571bdbeaa39d5be$var$animationDuration, ()=>{
            overlay.style.display = "none";
            delete pm.openedPopups[name];
        });
        return;
    }
    jQuery(popup).stop().animate({
        bottom: "-100%"
    }, $0571bdbeaa39d5be$var$animationDuration + 100, ()=>{
        delete pm.openedPopups[name];
    });
}
function $0571bdbeaa39d5be$export$62f40777801d8f79(popupName) {
    document.addEventListener("click", (e)=>{
        const target = e.target;
        if (!(target instanceof Element)) return;
        const button = $0571bdbeaa39d5be$var$getClosest(target, ".open-" + popupName + "-popup", 5);
        if (!button) return;
        e.preventDefault();
        const overlay = $0571bdbeaa39d5be$var$findHtmlEl("." + popupName + "-popup-overlay");
        const popup = $0571bdbeaa39d5be$var$findHtmlEl("." + popupName + "-popup");
        if (popup && overlay) pm.event.emit("pm_popup_trigger_clicked", {
            name: popupName,
            popup: popup,
            overlay: overlay,
            triggerButton: button
        });
        $0571bdbeaa39d5be$export$c70811ece640d3a1(popupName, button);
    });
}
function $0571bdbeaa39d5be$export$d96ccb675a3220ef(popupName) {
    document.addEventListener("click", (e)=>{
        const target = e.target;
        if (!(target instanceof Element)) return;
        const trigger = $0571bdbeaa39d5be$var$getClosest(target, ".open-" + popupName + "-popup", 5);
        if (trigger) return;
        const popup = $0571bdbeaa39d5be$var$getClosest(target, "." + popupName + "-popup", 30);
        if (popup) return;
        const overlay = $0571bdbeaa39d5be$var$getClosest(target, "." + popupName + "-popup-overlay", 30);
        if (overlay?.classList.contains("unclosable")) return;
        if (overlay) $0571bdbeaa39d5be$export$e6889fb0929ccf91(popupName);
    });
    document.addEventListener("keydown", (e)=>{
        const key = e.key.toLowerCase();
        if (key !== "escape" && key !== "esc") return;
        if (!Object.keys(pm.openedPopups).length) return;
        // Get item from openedPopups object that has the highest timestamp.
        const lastOpenedPopup = Object.entries(pm.openedPopups).sort((a, b)=>b[1] - a[1]).shift();
        const lastOpenedPopupName = lastOpenedPopup?.[0];
        if (lastOpenedPopupName && lastOpenedPopupName === popupName) {
            const overlay = $0571bdbeaa39d5be$var$findHtmlEl("." + lastOpenedPopupName + "-popup-overlay");
            if (overlay?.classList.contains("unclosable")) return;
            $0571bdbeaa39d5be$export$e6889fb0929ccf91(lastOpenedPopupName);
        }
    });
    document.addEventListener("click", (e)=>{
        const target = e.target;
        if (!(target instanceof Element)) return;
        const closeButton = $0571bdbeaa39d5be$var$getClosest(target, ".close-popup", 5);
        if (!closeButton) return;
        const overlay = $0571bdbeaa39d5be$var$findHtmlEl("." + popupName + "-popup-overlay");
        if (overlay?.classList.contains("unclosable")) return;
        const popup = $0571bdbeaa39d5be$var$getClosest(closeButton, "." + popupName + "-popup", 10);
        if (!popup) return;
        $0571bdbeaa39d5be$export$e6889fb0929ccf91(popupName);
    });
}



let $dc5d6aac500df017$var$doingAjax = false;
function $dc5d6aac500df017$export$2e2bcd8739ae039(form) {
    const { findHtmlEl: findHtmlEl, findButtonEl: findButtonEl, findSelectEl: findSelectEl } = pm.utils.dom;
    const objectType = form.dataset.reportedObjectType;
    const notice = findHtmlEl(form, ".submission-notice");
    if (notice) (0, $03c150816e9a7def$export$3bddf9505d6a7871)(notice);
    const reasonSelectbox = findSelectEl(form, '[name="' + objectType + '_reporting_reason"]');
    const reason = reasonSelectbox ? reasonSelectbox.value : "other";
    const button = findButtonEl(form, ".submit-button");
    if ($dc5d6aac500df017$var$doingAjax) return;
    $dc5d6aac500df017$var$doingAjax = true;
    (0, $2e33a4f4aeb13ba1$export$fea330ef6103f535)(button);
    const formData = new FormData();
    const triggerOrigin = form.dataset.triggerOrigin ? form.dataset.triggerOrigin : "";
    if (objectType === "photo") {
        if (triggerOrigin === "context-menu") formData.append("as_curator", "1");
        else if (triggerOrigin === "photo-popup") formData.append("from_photo_popup", "1");
    } else if (objectType === "comment") {
        if (triggerOrigin === "photo-popup") formData.append("from_photo_popup", "1");
    }
    formData.append("action", "pm_report_" + objectType);
    formData.append("nonce", form.dataset.pmNonce ? form.dataset.pmNonce : "");
    formData.append(objectType + "_id", form.dataset.reportedObjectId ? form.dataset.reportedObjectId : "");
    formData.append("reason", reason);
    (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
        method: "post",
        url: pm.ajaxurl,
        data: formData
    }).then((response)=>{
        if (!response.data || !response.data.success) {
            const errorMsg = (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response);
            if (notice) (0, $03c150816e9a7def$export$b25305d7fdb340d7)(notice, errorMsg, "error");
            return;
        }
        if (notice) (0, $03c150816e9a7def$export$b25305d7fdb340d7)(notice, response.data.data, "success");
        setTimeout(()=>{
            (0, $0571bdbeaa39d5be$export$e6889fb0929ccf91)("reporting");
        }, 3000);
    }).catch((response)=>{
        const errorMsg = (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response);
        if (notice) (0, $03c150816e9a7def$export$b25305d7fdb340d7)(notice, errorMsg, "error");
    }).then(()=>{
        $dc5d6aac500df017$var$doingAjax = false;
        (0, $2e33a4f4aeb13ba1$export$4dabcd056c1d895c)(button);
    });
}


function $62eb1fd4eaefc1bb$export$9b354c8b74857e02() {
    const getClosest = pm.utils.dom.getClosest;
    const findHtmlEl = pm.utils.dom.findHtmlEl;
    const findHtmlEls = pm.utils.dom.findHtmlEls;
    const notice = pm.utils.notice;
    pm.event.on("pm_popup_will_open", (opts)=>{
        const popup = opts.popup;
        const trigger = opts.triggerButton;
        const form = findHtmlEl(popup, ".reporting-form");
        if (!form || !trigger) return;
        const reportedObjectType = trigger.dataset.reportedObjectType;
        let triggerOrigin = "";
        if (trigger.hasAttribute("data-trigger-origin")) triggerOrigin = trigger.dataset.triggerOrigin ? trigger.dataset.triggerOrigin : "";
        form.dataset.reportedObjectType = reportedObjectType;
        if (trigger.hasAttribute("data-reported-object-id")) form.dataset.reportedObjectId = trigger.dataset.reportedObjectId;
        form.dataset.triggerOrigin = "";
        if (reportedObjectType === "photo") {
            if (triggerOrigin === "context-menu") {
                const contextMenu = getClosest(trigger, ".context-menu", 15);
                if (!contextMenu) return;
                form.dataset.reportedObjectId = contextMenu.dataset.photoId;
                form.dataset.triggerOrigin = "context-menu";
            } else if (triggerOrigin === "photo-popup") form.dataset.triggerOrigin = "photo-popup";
        } else if (reportedObjectType === "comment") {
            if (triggerOrigin === "photo-popup") form.dataset.triggerOrigin = "photo-popup";
        }
        if (triggerOrigin === "photo-popup") {
            const popup = getClosest(trigger, ".photo-popup", 20);
            if (popup) {
                if (reportedObjectType === "comment") form.dataset.pmNonce = popup.dataset.reportCommentNonce;
                else if (reportedObjectType === "photo") form.dataset.pmNonce = popup.dataset.reportPhotoNonce;
            }
        } else form.dataset.pmNonce = trigger.dataset.reportingNonce;
        const reasonSelectboxes = findHtmlEls(form, ".reporting-reason");
        if (!reasonSelectboxes.length) return;
        reasonSelectboxes.forEach((selectbox)=>{
            if (!(selectbox instanceof HTMLSelectElement)) return;
            if (selectbox.name === reportedObjectType + "_reporting_reason") selectbox.classList.remove("is-hidden");
            else selectbox.classList.add("is-hidden");
            selectbox.value = "";
        });
        const popupTitle = findHtmlEl(popup, ".popup-title");
        if (popupTitle) popupTitle.textContent = "Report " + reportedObjectType;
        const submitButton = findHtmlEl(popup, ".submit-button");
        if (submitButton) submitButton.textContent = "Report this " + reportedObjectType;
        const noticeEl = findHtmlEl(form, ".submission-notice");
        if (noticeEl) notice.hide(noticeEl);
        const objectTypeTags = findHtmlEls(form, ".object-type-tag");
        if (objectTypeTags.length) objectTypeTags.forEach((tag)=>{
            tag.textContent = reportedObjectType ? reportedObjectType : "";
        });
    });
}
function $62eb1fd4eaefc1bb$export$5742d9009ada49ac() {
    const form = pm.utils.dom.findHtmlEl(".reporting-form");
    if (!form) return;
    form.addEventListener("submit", function(e) {
        e.preventDefault();
        (0, $dc5d6aac500df017$export$2e2bcd8739ae039)(form);
    });
}




/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */ var $4187f6dacff6fa61$var$EN_US = [
    'second',
    'minute',
    'hour',
    'day',
    'week',
    'month',
    'year'
];
function $4187f6dacff6fa61$export$2e2bcd8739ae039(diff, idx) {
    if (idx === 0) return [
        'just now',
        'right now'
    ];
    var unit = $4187f6dacff6fa61$var$EN_US[Math.floor(idx / 2)];
    if (diff > 1) unit += 's';
    return [
        diff + " " + unit + " ago",
        "in " + diff + " " + unit
    ];
}


var $a4e0e67bf524ccde$var$ZH_CN = [
    "\u79D2",
    "\u5206\u949F",
    "\u5C0F\u65F6",
    "\u5929",
    "\u5468",
    "\u4E2A\u6708",
    "\u5E74"
];
function $a4e0e67bf524ccde$export$2e2bcd8739ae039(diff, idx) {
    if (idx === 0) return [
        "\u521A\u521A",
        "\u7247\u523B\u540E"
    ];
    var unit = $a4e0e67bf524ccde$var$ZH_CN[~~(idx / 2)];
    return [
        diff + " " + unit + "\u524D",
        diff + " " + unit + "\u540E"
    ];
}


/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */ /**
 * All supported locales
 */ var $cd28697916b37f18$var$Locales = {};
var $cd28697916b37f18$export$6503ec6e8aabbaf = function(locale, func) {
    $cd28697916b37f18$var$Locales[locale] = func;
};
var $cd28697916b37f18$export$180605366c04f0cd = function(locale) {
    return $cd28697916b37f18$var$Locales[locale] || $cd28697916b37f18$var$Locales['en_US'];
};


/**
 * Created by hustcc on 18/5/20.
 * Contract: i@hust.cc
 */ var $7b470b97567de5f7$var$SEC_ARRAY = [
    60,
    60,
    24,
    7,
    365 / 7 / 12,
    12
];
function $7b470b97567de5f7$export$e67a095c620b86fe(input) {
    if (input instanceof Date) return input;
    // @ts-ignore
    if (!isNaN(input) || /^\d+$/.test(input)) return new Date(parseInt(input));
    input = (input || '')// @ts-ignore
    .trim().replace(/\.\d+/, '') // remove milliseconds
    .replace(/-/, '/').replace(/-/, '/').replace(/(\d)T(\d)/, '$1 $2').replace(/Z/, ' UTC') // 2017-2-5T3:57:52Z -> 2017-2-5 3:57:52UTC
    .replace(/([+-]\d\d):?(\d\d)/, ' $1$2'); // -04:00 -> -0400
    return new Date(input);
}
function $7b470b97567de5f7$export$d366f7e475ff66b0(diff, localeFunc) {
    /**
     * if locale is not exist, use defaultLocale.
     * if defaultLocale is not exist, use build-in `en`.
     * be sure of no error when locale is not exist.
     *
     * If `time in`, then 1
     * If `time ago`, then 0
     */ var agoIn = diff < 0 ? 1 : 0;
    /**
     * Get absolute value of number (|diff| is non-negative) value of x
     * |diff| = diff if diff is positive
     * |diff| = -diff if diff is negative
     * |0| = 0
     */ diff = Math.abs(diff);
    /**
     * Time in seconds
     */ var totalSec = diff;
    /**
     * Unit of time
     */ var idx = 0;
    for(; diff >= $7b470b97567de5f7$var$SEC_ARRAY[idx] && idx < $7b470b97567de5f7$var$SEC_ARRAY.length; idx++)diff /= $7b470b97567de5f7$var$SEC_ARRAY[idx];
    /**
     * Math.floor() is alternative of ~~
     *
     * The differences and bugs:
     * Math.floor(3.7) -> 4 but ~~3.7 -> 3
     * Math.floor(1559125440000.6) -> 1559125440000 but ~~1559125440000.6 -> 52311552
     *
     * More information about the performance of algebraic:
     * https://www.youtube.com/watch?v=65-RbBwZQdU
     */ diff = Math.floor(diff);
    idx *= 2;
    if (diff > (idx === 0 ? 9 : 1)) idx += 1;
    return localeFunc(diff, idx, totalSec)[agoIn].replace('%s', diff.toString());
}
function $7b470b97567de5f7$export$46cb85a2e475f1c7(date, relativeDate) {
    var relDate = relativeDate ? $7b470b97567de5f7$export$e67a095c620b86fe(relativeDate) : new Date();
    return (+relDate - +$7b470b97567de5f7$export$e67a095c620b86fe(date)) / 1000;
}
function $7b470b97567de5f7$export$f001eed3768ccc81(diff) {
    var rst = 1, i = 0, d = Math.abs(diff);
    for(; diff >= $7b470b97567de5f7$var$SEC_ARRAY[i] && i < $7b470b97567de5f7$var$SEC_ARRAY.length; i++){
        diff /= $7b470b97567de5f7$var$SEC_ARRAY[i];
        rst *= $7b470b97567de5f7$var$SEC_ARRAY[i];
    }
    d = d % rst;
    d = d ? rst - d : rst;
    return Math.ceil(d);
}



var $eea8709ff09986a1$export$d9468344d3651243 = function(date, locale, opts) {
    // diff seconds
    var sec = (0, $7b470b97567de5f7$export$46cb85a2e475f1c7)(date, opts && opts.relativeDate);
    // format it with locale
    return (0, $7b470b97567de5f7$export$d366f7e475ff66b0)(sec, (0, $cd28697916b37f18$export$180605366c04f0cd)(locale));
};


var $e536567b8e1d6570$var$ATTR_TIMEAGO_TID = 'timeago-id';
function $e536567b8e1d6570$export$fc264540bc854f77(node) {
    return node.getAttribute('datetime');
}
function $e536567b8e1d6570$export$8d0f47365a7f2d89(node, timerId) {
    // @ts-ignore
    node.setAttribute($e536567b8e1d6570$var$ATTR_TIMEAGO_TID, timerId);
}
function $e536567b8e1d6570$export$37dc273d2a45ee0f(node) {
    return parseInt(node.getAttribute($e536567b8e1d6570$var$ATTR_TIMEAGO_TID));
}




// all realtime timer
var $ef608bf0cc078cd4$var$TIMER_POOL = {};
/**
 * clear a timer from pool
 * @param tid
 */ var $ef608bf0cc078cd4$var$clear = function(tid) {
    clearTimeout(tid);
    delete $ef608bf0cc078cd4$var$TIMER_POOL[tid];
};
// run with timer(setTimeout)
function $ef608bf0cc078cd4$var$run(node, date, localeFunc, opts) {
    // clear the node's exist timer
    $ef608bf0cc078cd4$var$clear((0, $e536567b8e1d6570$export$37dc273d2a45ee0f)(node));
    var relativeDate = opts.relativeDate, minInterval = opts.minInterval;
    // get diff seconds
    var diff = (0, $7b470b97567de5f7$export$46cb85a2e475f1c7)(date, relativeDate);
    // render
    node.innerText = (0, $7b470b97567de5f7$export$d366f7e475ff66b0)(diff, localeFunc);
    var tid = setTimeout(function() {
        $ef608bf0cc078cd4$var$run(node, date, localeFunc, opts);
    }, Math.min(Math.max((0, $7b470b97567de5f7$export$f001eed3768ccc81)(diff), minInterval || 1) * 1000, 0x7fffffff));
    // there is no need to save node in object. Just save the key
    $ef608bf0cc078cd4$var$TIMER_POOL[tid] = 0;
    (0, $e536567b8e1d6570$export$8d0f47365a7f2d89)(node, tid);
}
function $ef608bf0cc078cd4$export$70b61ad426ddbe54(node) {
    // cancel one
    if (node) $ef608bf0cc078cd4$var$clear((0, $e536567b8e1d6570$export$37dc273d2a45ee0f)(node));
    else Object.keys($ef608bf0cc078cd4$var$TIMER_POOL).forEach($ef608bf0cc078cd4$var$clear);
}
function $ef608bf0cc078cd4$export$b3890eb0ae9dca99(nodes, locale, opts) {
    // by .length
    // @ts-ignore
    var nodeList = nodes.length ? nodes : [
        nodes
    ];
    nodeList.forEach(function(node) {
        $ef608bf0cc078cd4$var$run(node, (0, $e536567b8e1d6570$export$fc264540bc854f77)(node), (0, $cd28697916b37f18$export$180605366c04f0cd)(locale), opts || {});
    });
    return nodeList;
}


(0, $cd28697916b37f18$export$6503ec6e8aabbaf)('en_US', (0, $4187f6dacff6fa61$export$2e2bcd8739ae039));
(0, $cd28697916b37f18$export$6503ec6e8aabbaf)('zh_CN', (0, $a4e0e67bf524ccde$export$2e2bcd8739ae039));


function $fa16e4cdef8d0bc7$export$2e2bcd8739ae039() {
    const { findHtmlEl: findHtmlEl, findHtmlEls: findHtmlEls, getClosest: getClosest } = pm.utils.dom;
    let isOpen = false;
    let isRequesting = false;
    const menuItem = findHtmlEl(".notif-menu-item");
    if (!menuItem) return;
    const menuLink = findHtmlEl(menuItem, ".notif-icon-link");
    const newNotifIndicator = findHtmlEl(menuItem, ".new-notif-indicator");
    const newNotifNumber = newNotifIndicator ? findHtmlEl(newNotifIndicator, ".new-notif-number") : null;
    const dropdown = findHtmlEl(".notif-menu-item .notif-dropdown");
    const allList = dropdown ? findHtmlEls(dropdown, ".notif-item") : [];
    const unreadList = dropdown ? findHtmlEls(dropdown, ".notif-item.is-unread") : [];
    let hasUnread = unreadList.length ? true : false;
    let waitToRemoveReadIndicator = false;
    function init() {
        menuLink?.addEventListener("click", toggleDropdown);
        newNotifIndicator?.addEventListener("click", toggleDropdown);
        jQuery(document).on("click", function(e) {
            if (jQuery(e.target).closest(".notif-menu-item").length === 0) closeDropdown();
        });
        dropdown?.addEventListener("click", function(e) {
            const target = e.target;
            if (!(target instanceof Element)) return;
            if (target instanceof HTMLAnchorElement) return;
            const link = getClosest(target, ".notif-link", 10);
            if (link) return;
            const li = getClosest(target, ".notif-item");
            if (!li) return;
            window.location.href = li.dataset.notifUrl ?? "";
        });
    }
    function toggleDropdown(e) {
        e.preventDefault();
        if (isOpen) {
            closeDropdown();
            return;
        }
        openDropdown();
    }
    function openDropdown() {
        isOpen = true;
        formatTimes();
        dropdown?.classList.add("is-open");
        readNotif();
    }
    function closeDropdown() {
        dropdown?.classList.remove("is-open");
        if (waitToRemoveReadIndicator) {
            unreadList.forEach(function(unreadItem) {
                unreadItem.classList.remove("is-unread");
            });
            newNotifIndicator?.classList.add("is-hidden");
            if (newNotifNumber) newNotifNumber.innerHTML = "0";
            waitToRemoveReadIndicator = false;
        }
        isOpen = false;
    }
    function formatTimes() {
        allList.forEach(function(item) {
            const timeDiv = findHtmlEl(item, ".notif-time");
            if (!timeDiv) return;
            timeDiv.innerHTML = (0, $eea8709ff09986a1$export$d9468344d3651243)(timeDiv.dataset.notifTime + " UTC");
        });
    }
    function readNotif() {
        if (!hasUnread) return;
        if (isRequesting) return;
        isRequesting = true;
        const notifIds = [];
        unreadList.forEach(function(unreadItem) {
            if (!unreadItem.dataset.notifId) return;
            const notifId = parseInt(unreadItem.dataset.notifId, 10);
            notifIds.push(notifId);
        });
        const data = {
            nonce: pm.nonces.readNotif,
            action: "pm_read_notif",
            notif_ids: notifIds
        };
        jQuery.ajax({
            url: pm.ajaxurl,
            type: "post",
            data: data
        }).done(function(r) {
            if (!r || !r.success) return;
            hasUnread = false;
            waitToRemoveReadIndicator = true;
        }).always(function(jqXHR) {
            isRequesting = true;
        });
    }
    init();
}


function $93eef947ce72aad4$export$2e2bcd8739ae039() {
    let doingAjax = false;
    init();
    /**
   * Initialize the module, call the main functions.
   *
   * This function is the only function that should be called on top level scope.
   * Other functions are called / hooked from this function.
   */ function init() {
        jQuery(document).on("click", ".follow-action", followOrUnfollowUser);
    }
    /**
   * Follow or unfollow user.
   */ function followOrUnfollowUser(e) {
        if (!document.body.classList.contains("logged-in")) return;
        e.preventDefault();
        if (doingAjax) return;
        this.classList.add("is-processing");
        doingAjax = true;
        const button = this;
        const actionType = button.dataset.actionType;
        if ("follow" === actionType) followUser(button);
        else unfollowUser(button);
        jQuery.ajax({
            url: pm.ajaxurl,
            type: "POST",
            data: {
                action: "pm_save_follow_action",
                nonce: pm.nonces.followOrUnfollowUser,
                user_id: button.dataset.userId,
                action_type: actionType
            }
        }).done(function(r) {
            if (r.success) return;
            if ("follow" === actionType) unfollowUser(button);
            else followUser(button);
            pm.utils.alert.show("error", r.data);
        }).fail(function() {
            if ("follow" === actionType) unfollowUser(button);
            else followUser(button);
            pm.utils.alert.show("error", "Something went wrong. Please try again.");
        }).always(function() {
            doingAjax = false;
            button.classList.remove("is-processing");
        });
    }
    function followUser(button) {
        const textSpan = button.querySelector(".button-text");
        if (textSpan) textSpan.textContent = "Following";
        const titleEl = button.querySelector("title");
        if (titleEl) titleEl.textContent = "Unfollow this artist";
        button.dataset.actionType = "unfollow";
        button.classList.add("is-active");
    }
    function unfollowUser(button) {
        const textSpan = button.querySelector(".button-text");
        if (textSpan) textSpan.textContent = "Follow";
        const titleEl = button.querySelector("title");
        if (titleEl) titleEl.textContent = "Follow this artist";
        button.dataset.actionType = "follow";
        button.classList.remove("is-active");
    }
    return {};
}



function $bb99674f0bb2599e$export$2e2bcd8739ae039($) {
    const { findHtmlEl: findHtmlEl, findInputEl: findInputEl } = pm.utils.dom;
    findInputEl("#guidelines-agreement")?.addEventListener("change", function() {
        const guidelinesButton = findHtmlEl(".guidelines-button");
        if (!guidelinesButton) return;
        if (this.checked) {
            guidelinesButton.classList.remove("disabled");
            guidelinesButton.classList.remove("wpbf-button-secondary");
            guidelinesButton.classList.add("wpbf-button-primary");
        } else {
            guidelinesButton.classList.add("disabled");
            guidelinesButton.classList.add("wpbf-button-secondary");
            guidelinesButton.classList.remove("wpbf-button-primary");
        }
    });
    $("#guidelines-agreement").on("click", function() {
        $(".guidelines-button").removeClass("disabled").removeClass("wpbf-button-secondary").addClass("wpbf-button-primary");
    });
    $(".guidelines-button").on("click", function(event) {
        event.preventDefault();
        var button = this;
        button.classList.add("is-loading");
        $.ajax({
            type: "POST",
            url: pm.ajaxurl,
            data: {
                action: "pm_accept_guidelines",
                nonce: pm.nonces.acceptGuidelines
            }
        }).done(function(r) {
            (0, $0571bdbeaa39d5be$export$e6889fb0929ccf91)("guidelines");
            $(".open-guidelines-popup").removeClass("open-guidelines-popup");
        }).fail(function() {
            alert("Something went wrong. Please try again.");
        }).always(function() {
            button.classList.remove("is-loading");
        });
    });
}






const $a85d853c1130fc3c$export$775110cf9d00cf34 = async (data)=>{
    try {
        const formData = new FormData();
        for(const key in data)if (data.hasOwnProperty(key)) {
            const value = data[key];
            formData.append(key, value);
        }
        const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports))).post(pm.ajaxurl, formData);
        if (!axiosResponse.data || !axiosResponse.data.success) return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$834dfce7b095c052)(axiosResponse)
        };
        return {
            success: true,
            message: "Data has been edited successfully.",
            data: axiosResponse.data.data
        };
    } catch (response) {
        return {
            success: false,
            message: (0, $1c8afd417561b3bb$export$546f71b8cb2147a0)(response)
        };
    }
};


function $99ff9123b309d8af$export$2e2bcd8739ae039(block) {
    const findHtmlEl = pm.utils.dom.findHtmlEl;
    block.classList.remove("is-editing");
    const triggerButton = findHtmlEl(block, ".inline-edit-button");
    triggerButton?.parentElement?.classList.remove("is-hidden");
    const actionButtonsWrapper = findHtmlEl(block, ".action-buttons");
    actionButtonsWrapper?.classList.add("is-hidden");
    const errorMessageEl = findHtmlEl(block, ".wpbf-notice-error");
    if (errorMessageEl) errorMessageEl.classList.add("is-hidden");
    const contentWrapper = findHtmlEl(block, ".content-wrapper");
    if (contentWrapper) contentWrapper.classList.remove("is-hidden");
    const editor = findHtmlEl(block, ".content-editor");
    if (editor) {
        const suffixEl = findHtmlEl(block, ".field-suffix");
        editor.classList.add("is-hidden");
        if (suffixEl) suffixEl.classList.add("is-hidden");
    }
}


function $92c493e43f08e288$export$6104e3b4c48e4d36(block) {
    const findHtmlEl = pm.utils.dom.findHtmlEl;
    block.classList.remove("is-editing");
    const triggerButtonsWrapper = findHtmlEl(block, ".trigger-buttons");
    triggerButtonsWrapper?.classList.remove("is-hidden");
    const actionButtonsWrapper = findHtmlEl(block, ".action-buttons");
    actionButtonsWrapper?.classList.add("is-hidden");
    const errorMessageEl = findHtmlEl(block, ".wpbf-notice-error");
    if (errorMessageEl) errorMessageEl.classList.add("is-hidden");
    const contentWrapper = findHtmlEl(block, ".content-wrapper");
    if (contentWrapper) contentWrapper.classList.remove("is-hidden");
    const editor = findHtmlEl(block, ".content-editor");
    if (editor) editor.classList.add("is-hidden");
    const suffixEl = findHtmlEl(block, ".field-suffix");
    if (suffixEl) suffixEl.classList.add("is-hidden");
}
function $92c493e43f08e288$export$7edb076e2da4711f(blockToSkip) {
    const blocks = pm.utils.dom.findHtmlEls(".inline-editing");
    if (!blocks.length) return;
    blocks.forEach(function(block) {
        if (blockToSkip && blockToSkip == block) return;
        $92c493e43f08e288$export$6104e3b4c48e4d36(block);
    });
}



function $f6b05f39d0944d90$export$2e2bcd8739ae039(block, triggerButton) {
    const findHtmlEl = pm.utils.dom.findHtmlEl;
    block.classList.add("is-editing");
    triggerButton.parentElement?.classList.add("is-hidden");
    const actionButtonsWrapper = findHtmlEl(block, ".action-buttons");
    actionButtonsWrapper?.classList.remove("is-hidden");
    const contentWrapper = findHtmlEl(block, ".content-wrapper");
    if (contentWrapper) contentWrapper.classList.add("is-hidden");
    const editor = findHtmlEl(block, ".content-editor");
    if (editor) {
        editor.classList.remove("is-hidden");
        editor.focus();
    }
    const suffixEl = findHtmlEl(block, ".field-suffix");
    if (suffixEl) suffixEl.classList.remove("is-hidden");
    (0, $92c493e43f08e288$export$7edb076e2da4711f)(block);
}


function $4119e11fdb266df3$export$2e2bcd8739ae039() {
    const { getClosest: getClosest, findHtmlEl: findHtmlEl } = pm.utils.dom;
    let doingAjax = false;
    init();
    function init() {
        document.addEventListener("click", handleEditButtonClick);
        document.addEventListener("click", handleSaveButtonClick);
        document.addEventListener("click", handleCancelButtonClick);
        document.addEventListener("dblclick", handleDocumentDblClick);
        window.addEventListener("keydown", handleDocumentKeyDown);
        window.addEventListener("keydown", handleEditorKeydown);
    }
    function handleEditButtonClick(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const button = getClosest(target, ".inline-edit-button");
        if (!(button instanceof HTMLElement)) return;
        const block = getClosest(button, ".inline-editing");
        if (!(block instanceof HTMLElement)) return;
        (0, $f6b05f39d0944d90$export$2e2bcd8739ae039)(block, button);
    }
    async function handleSaveButtonClick(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const button = getClosest(target, ".save-button", 8);
        if (!(button instanceof HTMLButtonElement)) return;
        const block = getClosest(target, ".inline-editing");
        if (!(block instanceof HTMLElement)) return;
        await saveContent(block);
    }
    function handleCancelButtonClick(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const button = getClosest(target, ".cancel-button", 8);
        if (!(button instanceof HTMLButtonElement)) return;
        const block = getClosest(target, ".inline-editing");
        if (!(block instanceof HTMLElement)) return;
        (0, $99ff9123b309d8af$export$2e2bcd8739ae039)(block);
    }
    function handleDocumentDblClick(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const contentWrapper = getClosest(target, ".is-content-editable", 8);
        if (!contentWrapper) return;
        const block = getClosest(contentWrapper, ".inline-editing");
        if (!(block instanceof HTMLElement)) return;
        const button = findHtmlEl(block, ".inline-edit-button");
        if (!(button instanceof HTMLElement)) return;
        e.preventDefault();
        (0, $f6b05f39d0944d90$export$2e2bcd8739ae039)(block, button);
    }
    function handleDocumentKeyDown(e) {
        if (!e.key) return;
        const key = e.key.toLowerCase();
        if (key === "escape" || key === "esc") {
            if (document.body.classList.contains("has-photo-popup-opened")) // Wait for a 100ms, maybe other script (such as photo popup) is checking for the inline-editing state.
            setTimeout(exitAllEditModesAfterTimeout, 200);
            else (0, $92c493e43f08e288$export$7edb076e2da4711f)();
        }
    }
    function exitAllEditModesAfterTimeout() {
        (0, $92c493e43f08e288$export$7edb076e2da4711f)();
    }
    async function handleEditorKeydown(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const editor = getClosest(target, ".content-editor", 2);
        if (!editor) return;
        if (editor.tagName.toLocaleLowerCase() !== "input") return;
        const key = e.key.toLowerCase();
        if (key !== "enter") return;
        e.preventDefault();
        const block = getClosest(editor, ".inline-editing");
        if (block instanceof HTMLElement) await saveContent(block);
    }
    async function saveContent(block) {
        if (doingAjax) return;
        doingAjax = true;
        const saveButton = findHtmlEl(block, ".save-button");
        const editor = findHtmlEl(block, ".content-editor");
        if (saveButton) (0, $2e33a4f4aeb13ba1$export$fea330ef6103f535)(saveButton);
        const errorMessageEl = findHtmlEl(block, ".wpbf-notice-error");
        if (errorMessageEl) {
            errorMessageEl.classList.add("is-hidden");
            errorMessageEl.innerHTML = "";
        }
        const contentType = block.dataset.contentType ?? "";
        const commentId = contentType === "comment" ? block.dataset.commentId : 0;
        const data = {
            nonce: pm.nonces.inlineEditing,
            action: "pm_inline_editing",
            post_id: block.dataset.postId ? parseInt(block.dataset.postId) : 0,
            content_type: contentType,
            content: editor instanceof HTMLTextAreaElement || editor instanceof HTMLInputElement ? editor.value : "",
            comment_id: commentId ? parseInt(commentId) : 0
        };
        const response = await (0, $a85d853c1130fc3c$export$775110cf9d00cf34)(data);
        if (!response.success) {
            if (errorMessageEl) {
                errorMessageEl.innerHTML = response.message ? response.message : "";
                errorMessageEl.classList.remove("is-hidden");
            }
            doingAjax = false;
            if (saveButton) (0, $2e33a4f4aeb13ba1$export$4dabcd056c1d895c)(saveButton);
            return;
        }
        let editorValue = response.data && response.data.editor ? response.data.editor : "";
        editorValue = editorValue.replace(/\\/g, "");
        if (editor instanceof HTMLTextAreaElement || editor instanceof HTMLInputElement) editor.value = editorValue;
        let output = response.data && response.data.output ? response.data.output : "";
        output = output.replace(/\\/g, "");
        const suffixEl = findHtmlEl(block, ".field-suffix");
        let emptyValue = block.dataset.emptyValue;
        emptyValue = emptyValue ? emptyValue : "";
        let formattedOutput = output;
        if (suffixEl) formattedOutput = formattedOutput ? formattedOutput + suffixEl.innerHTML : emptyValue;
        else formattedOutput = formattedOutput ? formattedOutput : emptyValue;
        const contentWrapper = findHtmlEl(block, ".content-wrapper");
        if (contentWrapper) {
            contentWrapper.innerHTML = formattedOutput;
            if (contentType === "photo_camera" && response.data) {
                if (contentWrapper.hasAttribute("href")) {
                    const cameraUrl = response.data.cameraUrl ?? "";
                    contentWrapper.setAttribute("href", cameraUrl);
                }
            }
        }
        const syncToAttr = block.dataset.syncToAttr;
        if (block.dataset.syncEditorTo) {
            const selector = block.dataset.syncEditorTo;
            const syncTarget = findHtmlEl(selector);
            if (syncTarget) {
                if (syncToAttr) syncTarget.setAttribute(syncToAttr, editorValue);
                else syncTarget.innerHTML = editorValue;
            }
        }
        if (block.dataset.syncOutputTo) {
            const selector = block.dataset.syncOutputTo;
            const syncTarget = findHtmlEl(selector);
            if (syncTarget) {
                if (syncToAttr) syncTarget.setAttribute(syncToAttr, output);
                else syncTarget.innerHTML = output;
            }
        }
        (0, $99ff9123b309d8af$export$2e2bcd8739ae039)(block);
        doingAjax = false;
        if (saveButton) (0, $2e33a4f4aeb13ba1$export$4dabcd056c1d895c)(saveButton);
    }
}


function $b6d08a6e4aa8081a$export$2e2bcd8739ae039() {
    const { findHtmlEl: findHtmlEl, findHtmlEls: findHtmlEls, getClosest: getClosest, listenDocumentEvent: listenDocumentEvent } = pm.utils.dom;
    function init() {
        const tabMenus = findHtmlEls(".tab-menu");
        // Initial state of the tabs.
        if (tabMenus.length) tabMenus.forEach(function(tabMenu) {
            const tabsWrapper = getClosest(tabMenu, ".tabs", 5);
            if (!tabsWrapper) return;
            const activeTabMenuItem = findHtmlEl(tabMenu, ".tab-menu-item.is-active");
            if (!activeTabMenuItem) return;
            switchTab(tabsWrapper, activeTabMenuItem.dataset.tabKey);
        });
        listenDocumentEvent("click", ".tab-menu-item", function(e) {
            if (!(e.target instanceof HTMLElement)) return;
            const target = e.target;
            const tabMenu = getClosest(target, ".tab-menu", 5);
            if (!tabMenu) return;
            const tabsWrapper = getClosest(tabMenu, ".tabs", 5);
            if (!tabsWrapper) return;
            const tabContent = findHtmlEl(tabsWrapper, ".tab-content");
            if (!tabContent) return;
            switchTab(tabsWrapper, target.dataset.tabKey);
        });
    }
    function switchTab(tabsWrapper, key) {
        if (!key) return;
        const tabMenu = findHtmlEl(tabsWrapper, ".tab-menu");
        if (tabMenu) {
            const tabMenuItems = findHtmlEls(tabMenu, ".tab-menu-item");
            if (tabMenuItems.length) tabMenuItems.forEach(function(tabMenuItem) {
                if (tabMenuItem.dataset.tabKey === key) tabMenuItem.classList.add("is-active");
                else tabMenuItem.classList.remove("is-active");
            });
        }
        const tabContent = findHtmlEl(tabsWrapper, ".tab-content");
        if (tabContent) {
            const tabContentItems = findHtmlEls(tabContent, ".tab-content-item");
            if (tabContentItems.length) tabContentItems.forEach(function(tabContentItem) {
                if (tabContentItem.dataset.tabKey === key) tabContentItem.classList.add("is-active");
                else tabContentItem.classList.remove("is-active");
            });
        }
        const conditionalEls = findHtmlEls(tabsWrapper, "[data-show-if-tab]");
        if (conditionalEls.length) conditionalEls.forEach(function(conditionalEl) {
            if (conditionalEl.dataset.showIfTab === key) conditionalEl.classList.remove("is-hidden");
            else conditionalEl.classList.add("is-hidden");
        });
        const tabsGroupName = tabsWrapper.dataset.tabsGroup;
        if (tabsGroupName) pm.event.emit("pm_tabs_switch", {
            tabsGroup: tabsGroupName,
            activeTabKey: key
        });
    }
    init();
}


function $800ad4e6ebbc5d19$export$2e2bcd8739ae039() {
    const { findHtmlEls: findHtmlEls, getClosest: getClosest } = pm.utils.dom;
    const modelKeyDataName = "data-model-key";
    const modelValueSelector = "[data-model-value]";
    document.addEventListener("DOMContentLoaded", handleDocumentReady);
    document.addEventListener("click", handleDocumentClick);
    function handleDocumentReady(_e) {
        const buttons = findHtmlEls(modelValueSelector);
        buttons.forEach(function(switchButton) {
            if (!switchButton.classList.contains("is-active")) return;
            handleCondition(switchButton);
        });
    }
    function handleDocumentClick(e) {
        const target = e.target;
        if (!(target instanceof Element)) return;
        const button = getClosest(target, modelValueSelector);
        if (!button) return;
        const parentEl = button.parentElement;
        if (!parentEl || !parentEl.hasAttribute(modelKeyDataName)) return;
        e.preventDefault();
        const buttons = findHtmlEls(parentEl, modelValueSelector);
        if (!buttons.length) return;
        buttons.forEach(function(switchButton) {
            const modelKey = parentEl.dataset.modelKey;
            if (!modelKey) return;
            if (switchButton === button) {
                switchButton.classList.add("is-active");
                pm.event.emit("data_model_switched_on", {
                    key: modelKey,
                    value: switchButton.dataset.modelValue ? switchButton.dataset.modelValue : ""
                });
            } else {
                switchButton.classList.remove("is-active");
                pm.event.emit("data_model_switched_off", {
                    key: modelKey,
                    value: switchButton.dataset.modelValue ? switchButton.dataset.modelValue : ""
                });
            }
        });
        handleCondition(button);
    }
    function handleCondition(button) {
        const parentEl = button.parentElement;
        const key = parentEl?.dataset.modelKey;
        const value = button.dataset.modelValue;
        if (!key || !value) return;
        handleShowIf(key, value);
        handleClassModel(key, value);
    }
    function handleShowIf(key, value) {
        const listenerEls = findHtmlEls('[data-show-if-key="' + key + '"]');
        if (!listenerEls.length) return;
        listenerEls.forEach(function(listenerEl) {
            if (listenerEl.dataset.showIfValue === value) listenerEl.classList.remove("is-hidden");
            else listenerEl.classList.add("is-hidden");
        });
    }
    function handleClassModel(key, value) {
        const listenerEls = findHtmlEls('[data-class-model="' + key + '"]');
        if (!listenerEls.length) return;
        const modelValuesEls = findHtmlEls("[" + modelKeyDataName + '="' + key + '"] ' + modelValueSelector);
        let modelValues = [];
        modelValuesEls.forEach(function(modelValueEl) {
            const modelValue = modelValueEl.dataset.modelValue ? modelValueEl.dataset.modelValue : "";
            modelValues.push(modelValue);
        });
        listenerEls.forEach(function(listenerEl) {
            if (listenerEl.hasAttribute("data-render-class-if-key")) {
                const renderClassIfKey = listenerEl.dataset.renderClassIfKey;
                let className = listenerEl.dataset.renderClass;
                if (renderClassIfKey === value) {
                    if (className) listenerEl.classList.add(className);
                } else if (className) listenerEl.classList.remove(className);
            } else modelValues.forEach(function(modelValue) {
                let className = listenerEl.dataset.renderClass;
                if (!className) return;
                className = className.replace("{{value}}", modelValue);
                if (modelValue === value) listenerEl.classList.add(className);
                else listenerEl.classList.remove(className);
            });
        });
    }
}



function $61c28ed01bf7c1d1$export$546f71b8cb2147a0(error) {
    if (error.response) {
        if (error.response.data) {
            if (error.response.data.message) return error.response.data.message;
            if (error.response.data.data) return error.response.data.data;
        }
    }
    if (error.message) return error.message;
    return "An unknown error occurred.";
}
function $61c28ed01bf7c1d1$export$834dfce7b095c052(response) {
    if (!response.data) return "Something went wrong.";
    if (!response.data.data && !response.data.message) return "Something went wrong.";
    if (response.data.message) return response.data.message;
    return response.data.data;
}


function $d45bd6c2ae9207f3$export$2e2bcd8739ae039() {
    const { findHtmlEl: findHtmlEl, findLinkEl: findLinkEl } = pm.utils.dom;
    window.addEventListener("load", function() {
        const popup = findHtmlEl(".paid-platform-anouncement-popup");
        if (!popup) return;
        pm.event.emit("pm_open_popup_via_api", {
            name: "paid-platform-anouncement"
        });
    });
    const markAsReadButton = findLinkEl(".paid-platform-anouncement-popup .mark-as-read");
    if (markAsReadButton) markAsReadButton.addEventListener("click", async function(e) {
        e.preventDefault();
        this.classList.add("is-loading");
        const response = await markAsRead();
        this.classList.remove("is-loading");
        window.location.href = this.href;
    });
    async function markAsRead() {
        const formData = new FormData();
        formData.append("action", "pm_read_paid_platform_announcement");
        try {
            const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
                method: "post",
                url: pm.ajaxurl,
                data: formData
            });
            return axiosResponse.data;
        } catch (response) {
            return {
                success: false,
                message: (0, $61c28ed01bf7c1d1$export$546f71b8cb2147a0)(response)
            };
        }
    }
}


(function() {
    const { findHtmlEl: findHtmlEl, findHtmlEls: findHtmlEls, getClosest: getClosest } = pm.utils.dom;
    const isLoggedIn = document.body.classList.contains("logged-in");
    const contextMenu = findHtmlEl(".context-menu");
    init();
    function init() {
        if (contextMenu) (0, $8b9578a55ec63129$export$2e2bcd8739ae039)();
        document.addEventListener("click", handleDocumentClick);
        FlexMasonry.init(".use-masonry", (0, $1fca4c7cd2abc6f7$export$611a8a3c17598af2));
        (0, $800ad4e6ebbc5d19$export$2e2bcd8739ae039)();
        (0, $b6d08a6e4aa8081a$export$2e2bcd8739ae039)();
        registerPopups();
        (0, $bb99674f0bb2599e$export$2e2bcd8739ae039)(jQuery);
        (0, $fa16e4cdef8d0bc7$export$2e2bcd8739ae039)();
        (0, $93eef947ce72aad4$export$2e2bcd8739ae039)();
        (0, $b82bf523941a899b$export$2e2bcd8739ae039)();
        (0, $100925dc27e05de3$export$2e2bcd8739ae039)();
        (0, $4119e11fdb266df3$export$2e2bcd8739ae039)();
        (0, $50f0c64592dcb09a$export$2e2bcd8739ae039)();
        setupAdsTracking();
        (0, $d45bd6c2ae9207f3$export$2e2bcd8739ae039)();
        setupReporting();
        (0, $fbe10e17a894f2b8$export$2e2bcd8739ae039)();
        (0, $942abde8c17ce155$export$2e2bcd8739ae039)();
        const photoMetadataArea = findHtmlEl(".metadata-mousemove");
        if (photoMetadataArea) (0, $f701c8e2633e7414$export$534a72f6c985c7fc)(photoMetadataArea);
    }
    function handleDocumentClick(e) {
        const target = e.target;
        if (!target) return;
        checkDeletePhoto(target);
    }
    function registerPopups() {
        const popupOverlays = findHtmlEls(".popup-overlay[data-popup-name]");
        if (popupOverlays.length) popupOverlays.forEach(function(popupOverlay) {
            const popupName = popupOverlay.dataset.popupName;
            if (!popupName) return;
            (0, $0571bdbeaa39d5be$export$62f40777801d8f79)(popupName);
            (0, $0571bdbeaa39d5be$export$d96ccb675a3220ef)(popupName);
        });
        pm.event.on("pm_open_popup_via_api", (opts)=>{
            (0, $0571bdbeaa39d5be$export$c70811ece640d3a1)(opts.name);
        });
    }
    function checkDeletePhoto(clickTarget) {
        if (!isLoggedIn) return;
        const deleteButton = getClosest(clickTarget, ".delete-photo", 10);
        if (!deleteButton) return;
        const isReview = deleteButton.classList.contains("is-review");
        const contextMenu = getClosest(deleteButton, ".context-menu", 5);
        const photoId = contextMenu ? contextMenu.dataset.photoId : deleteButton.dataset.photoId;
        if (!photoId) return;
        (0, $b39e31f00e7f553c$export$2e2bcd8739ae039)(photoId, isReview);
    }
    function setupAdsTracking() {
        pm.event.on("ad_loaded", (opts)=>{
            (0, $aee93ab2b11cc40f$export$2e2bcd8739ae039)(opts.id, "load");
        });
        document.addEventListener("click", (e)=>{
            const target = e.target;
            const adGridItem = getClosest(target, ".is-spc");
            if (!adGridItem) return;
            const adsIdStr = adGridItem.dataset.spcId;
            if (!adsIdStr) return;
            (0, $aee93ab2b11cc40f$export$2e2bcd8739ae039)(parseInt(adsIdStr, 10), "click");
        });
    }
    function setupReporting() {
        const popup = findHtmlEl(".reporting-popup");
        if (!popup) return;
        (0, $62eb1fd4eaefc1bb$export$9b354c8b74857e02)();
        (0, $62eb1fd4eaefc1bb$export$5742d9009ada49ac)();
    }
})();

})();
//# sourceMappingURL=site.js.map
